import { action, makeObservable, observable } from "mobx";
import { post, privatePost, setBearer } from "../utils/NetworkService";
import { setSession, getSession, setSessionJson, getSessionJson, clearAll } from '../utils/SessionService';

import language from '../utils/lang.json';
// import useGeoLocation from "react-ipgeolocation";


// import { Buffer } from "buffer";
import imageCompression from "browser-image-compression";
// import { debug } from "../utils/UtilConsole";
// import { faTintSlash } from "@fortawesome/free-solid-svg-icons";

class LoginState {
    member_no;
    authCode;
    email_address;
    member_nickname;
    profile_image;
    clover_count;
    stand_count;
    phone_no;
    constructor(memberData) {
        this.member_no = memberData?.member_no ?? null;
        this.authCode = memberData?.authCode ?? null;
        this.email_address = memberData?.email_address ?? null;
        this.member_nickname = memberData?.member_nickname ?? null;
        this.profile_image = memberData?.profile_image ?? null;
        this.clover_count = memberData?.clover_count ?? null;
        this.stand_count = memberData?.stand_count ?? null;
        this.phone_no = memberData?.phone_no ?? null;


    }
}



export class LoginStore {
    rootStore;
    CoinStore;

    loginState = getSessionJson('userInfo') ? new LoginState(getSessionJson('userInfo'), null) : new LoginState();
    // RecommenderState = getSessionJson('RecommenderInfo') ? new RecommenderState(getSessionJson('RecommenderInfo')) : new RecommenderState();

    isLogin = getSession("isLogin", false);
    loginFail = false;
    isSignUpDialogOpen = false;
    isWalletDialogOpen = false;
    isCoinSendDialogOpen = false;
    isMiningDialogOpen = false;
    isMiningTransformDialogOpen = false;
    isUserProfileDialogOpen = false;
    isVerifyDialogOpen = false;
    isAuthenticationDialogOpen = false;
    isGameMissionDialogOpen = false;
    isCloverSaleDialogOpen = false;
    isCloverMarketDialogOpen = false;
    isCloverMarketProductDialogOpen = false;
    isCloverMarketCouponitemDialogOpen = false;
    isCoinExchangeProposeDialogOpen = false;
    isCloverLockPageDialogOpen = false;









    Usercountry = "";

    SignUpImage = '';
    SignUpNickname = '';
    SignUpCommerce = '';
    SignUpBusinessCode = '';




    Guide_clover_memberShip = "회원가입";
    Guide_clover_memberImage_Button = "등록";
    GuideLabel_clover_nickName = "닉네임";
    GuideLabel_clover_recommender = "추천인";

    GuideSuccess_profileImage_size = '프로필 사진 등록 완료';


    ErrorGuide_clover_profileImage_size = '첨부파일 사이즈는 2.5MB 이내로 등록 가능합니다';



    Guide_clover_profile = "프로필 사진 등록";
    GuideNickName = '중복 체크 해주세요';
    GuideNickNameLength = '';
    GuideNickNameColor = '#fc0000';
    GuideProfileNicknameColor = "#fc0000";
    UserFrofileImageButtonColor = "#4fc3f7";
    GuideImage = '프로필 사진을 등록 해주세요';
    GuideRecommenderColor = 'blue';
    GuideRecommender = '검색해주세요';
    Guide_clover_profileNickname_count = "1000소모";
    GuideProfileRecommender = '검색해주세요';
    GuideProfileRecommenderColor = 'blue';
    Guide_clover_allPage_01 = "지갑주소를 입력해주세요";
    Guide_clover_allPage_02 = "수량을 입력해 주세요";
    Guide_clover_allPage_03 = "수수료확인";
    Guide_clover_allPage_04 = "개인정보 수집 이용 동의";
    Guide_clover_allPage_05 = "보내기";
    Guide_clover_allPage_06 = "회";
    Guide_clover_dialog_AuthenticationCheck_01 = "My.동의";
    Guide_clover_dialog_AuthenticationCheck_02 = "본인 인증을 위한 개인정보 수집 · 이용 및 제공, 위탁 동의서 \n 개인정보 보호법에 따라 (주)SoftBrain에 인증을 요청하시는 분께 \n 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부 시 \n 불이익에 관한 사항을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다. \n 1. 개인정보의 수집 및 이용목적 \n 서비스 이용시 이용자로부터 수집하는 개인정보는 아래와 같습니다. \n -회원정보 또는 개별 서비스에서 프로필 정보 ( 닉네임, 프로필 사진 )를 설정할 수 있습니다. \n 2. 수집하려는 개인정보의 항목 \n -인증 요청 시에 '휴대전화번호,이메일 주소'를 필수항목으로 수집합니다. \n 3.개인정보의 보유 및 이용기간 \n - 부정 가입 및 이용 방지 \n 탈퇴한 이용자의 휴대전화번호 : 탈퇴일로부터 6개월 보관 \n 4. 개인정보 수집 및 이용 동의를 거부할 권리 \n 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. \n 회원가입 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 인증 요청이 어려울 수 있습니다";
    Guide_clover_dialog_CoinSend_01 = "My.코인 이체";
    Guide_clover_dialog_CoinSend_02 = "My. 지갑";
    Guide_clover_dialog_DBCoinTransfer_01 = "코인 전환";
    Guide_clover_dialog_DBCoinTransfer_02 = "All";
    Guide_clover_dialog_DBCoinTransfer_03 = "수수료";
    Guide_clover_dialog_GameMission_01 = "My.게임미션";
    Guide_clover_dialog_GameMission_02 = "MAX";
    Guide_clover_dialog_Mining_01 = "채굴";
    Guide_clover_dialog_Mining_02 = "시간";
    Guide_clover_dialog_Mining_03 = "분";
    Guide_clover_dialog_Mining_04 = "초";
    Guide_clover_dialog_Mining_05 = "비용";
    Guide_clover_dialog_Mining_06 = "진행 중";
    Guide_clover_dialog_Mining_07 = "남은 정보";
    Guide_clover_dialog_Mining_08 = "보유";
    Guide_clover_dialog_Mining_09 = "채굴 정보";
    Guide_clover_dialog_Mining_11 = "수령 가능";
    Guide_clover_dialog_Mining_12 = "종류";
    Guide_clover_dialog_Mining_13 = "수량";
    Guide_clover_dialog_Mining_14 = "날짜";
    Guide_clover_dialog_Mining_button_01 = "수령";
    Guide_clover_dialog_Mining_button_02 = "내역";
    Guide_clover_dialog_Mining_button_03 = "채굴시작";
    Guide_clover_dialog_UserProfile_01 = "프로필";
    Guide_clover_dialog_UserProfile_03 = "my class";
    Guide_clover_dialog_UserProfile_04 = "Class.";
    Guide_clover_dialog_UserProfile_05 = "명의 추천인을 받을 수 있습니다.";
    Guide_clover_dialog_UserProfile_06 = "인증 완료 되었습니다";
    Guide_clover_dialog_UserProfile_08 = "소모";
    Guide_clover_dialog_UserProfile_09 = "추천대상자가 미션을 완수하면";
    Guide_clover_dialog_UserProfile_10 = "보상은 받습니다";
    Guide_clover_dialog_UserProfile_button_02 = "친구";
    Guide_clover_dialog_UserProfile_button_03 = "등급";
    Guide_clover_dialog_UserProfile_button_04 = "팔로잉";
    Guide_clover_dialog_UserProfile_button_05 = "팔로워";
    Guide_clover_dialog_UserProfile_button_07 = "인증 하기";
    Guide_clover_dialog_UserProfile_button_08 = "class 업";
    Guide_clover_dialog_Verify_01 = "My.인증";
    Guide_clover_dialog_Verify_02 = "번호확인";
    Guide_clover_dialog_Verify_03 = "인증확인";
    Guide_clover_dialog_Verify_04 = "전화번호를 입력해 주세요";
    Guide_clover_dialog_CloverSale_01 = "My.판매";
    Guide_clover_dialog_CloverSale_02 = "구매";
    Guide_clover_dialog_Walletinformation_01 = "My.지갑";
    Guide_clover_page_CloverMissionBar_01 = "Mission";
    Guide_clover_page_CloverMissionBar_02 = "업그레이드! 클릭";
    Guide_clover_page_CloverMissionBar_03 = "Limit";
    Guide_clover_page_MissionPmgBar_01 = "play";
    Guide_clover_page_MissionPmgBar_02 = "클릭해서 리워드를 /n 받으세요.";
    Guide_clover_page_MissionPmgBar_03 = "보상을 받으셨습니다";
    Guide_clover_page_MissionPmgBar_04 = "후 도전 가능";
    Guide_clover_page_topBar_01 = "Clover";
    Guide_clover_page_topBar_02 = "Login & join";
    Guide_clover_page_userBar_01 = "복사 하였습니다";
    Guide_clover_commission = "확인을 눌러 주세요";
    Guide_clover_userProfile_01 = "추천인 목록이 없습니다";
    Guide_clover_userProfile_02 = "친구 목록이 없습니다";
    Guide_clover_userProfile_03 = "팔로우 목록이 없습니다";
    Guide_clover_userProfile_04 = "인증확인 되었습니다";
    Guide_clover_userProfile_05 = "인증완료 되었습니다";
    ErrorGuide_clover_001 = "새로고침을 시도해주세요";
    ErrorGuide_clover_002 = "최종레벨에 도달 하셨습니다";
    ErrorGuide_clover_003 = "팡팡 최종레벨에 도달하셨습니다";
    ErrorGuide_clover_004 = "큐브 최종레벨에 도달하셨습니다";
    ErrorGuide_clover_005 = "코인이 부족합니다";
    ErrorGuide_clover_006 = "수수료가 차이가 있을 수 있습니다!";
    ErrorGuide_clover_007 = "지갑정보를 입력해주세요";
    ErrorGuide_clover_008 = "코인수량을 입력해주세요";
    ErrorGuide_clover_009 = "수량을 확인해주세요";
    ErrorGuide_clover_page_userBar_01 = "복사에 실패하였습니다";
    ErrorGuide_clover_page_userBar_02 = "복사하기가 지원되지 않는 브라우저입니다";
    ErrorGuide_clover_coin_001 = "지갑주소를 확인해주세요";
    ErrorGuide_clover_coin_003 = "지갑주소를 찾을 수 없습니다";
    ErrorGuide_clover_coin_004 = "거래소 정보를 불러 올 수 없습니다";
    ErrorGuide_clover_coin_005 = "코인 전송에 실패하였습니다";
    ErrorGuide_clover_coin_006 = "수수료가 부족합니다";
    ErrorGuide_501 = "잠시 후 다시 시도해주세요";
    ErrorGuide_810 = "중복입니다 다시 체크 해주세요";
    ErrorGuide_811 = "빈칸입니다 다시 체크 해주세요";
    ErrorGuide_812 = "특수문자는 닉네임으로 할 수 없습니다";
    ErrorGuide_814 = "클로버가 부족합니다";
    ErrorGuide_813 = "2글자 이상 20글자 미만으로 해주세요";
    ErrorGuide_815 = "닉네임에  욕설은 포함될수 없습니다";
    ErrorGuide_2400 = "클로버 구매를 실패하였습니다";
    ErrorGuide_3001 = "해당 유저를 찾을수 없습니다";
    ErrorGuide_3002 = "해당 유저의 추천인 등록 수가 최대치 입니다";
    ErrorGuide_3003 = "이미추천인을 등록하셨습니다";
    ErrorGuide_3004 = "자신을 추천인으로 등록 할 수 없습니다";
    ErrorGuide_3501 = "채굴정보가 없습니다";
    ErrorGuide_3505 = "완료된 채굴이 없습니다";
    ErrorGuide_3506 = "최대50회까지 가능합니다";
    ErrorGuide_3600 = "금일 미션이 완료 되었습니다";
    ErrorGuide_3601 = "플레이 횟수가 모자랍니다";
    ErrorGuide_clover_userProfile_01 = "유저를 찾을 수 없습니다";
    ErrorGuide_clover_userProfile_02 = "등급이 해당되지 않습니다";
    ErrorGuide_clover_userProfile_03 = "다음 레벨을 찾을 수 없습니다";
    ErrorGuide_clover_userProfile_04 = "다시 확인 해주세요";
    ErrorGuide_clover_userProfile_05 = "추천인이 없습니다";
    ErrorGuide_clover_userProfile_06 = "정보를 찾을 수 없습니다";
    ErrorGuide_clover_userProfile_07 = "추천인이 친구 리스트를 공유 하지 않습니다";
    ErrorGuide_clover_userProfile_08 = "추천인이 친구로 등록한 사람이 없습니다";
    Guid_recommender_confirm = "추천인을 확인해주세요";
    SuccessGuide_message = "완료되셨습니다";
    SuccessGuide_nickName_check = "체크 완료입니다";
    ErrorGuide_clover_010 = "이더리움이 부족합니다";
    ErrorGuide_3602 = "완료 할 수 없는 미션입니다";

    Guide_clover_dialog_Verify_05 = "인증번호를 입력해 주세요";
    Guide_clover_dialog_Mining_button_04 = "소요 시간";
    GuideLabel_clover_dialog_UserProfile_01 = "친구 공유";
    Guide_clover_dialog_UserProfile_11 = "{0}명 +";
    GuideCheck_clover_coinStore_message_01 = "보내시겠습니까?";
    GuideCheck_clover_coinStore_message_02 = "취소되었습니다";
    GuideCheck_clover_coinStore_message_03 = "닉네임을 등록 하시겠습니까?";
    GuideCheck_clover_coinStore_message_04 = "추천인을 등록 하시겠습니까?";
    GuideCheck_clover_coinStore_message_05 = "친구를 복사하시겠습니까?";
    ErrorGuide_3700 = "휴대전화 번호를 확인해 주세요.";
    ErrorGuide_3701 = "잘못된 코드 이거나 입력 시간이 초과 되었습니다.";
    ErrorGuide_3702 = "이미 인증 완료 되었습니다.";
    ErrorGuide_3703 = "금일 전송가능 문자개수를 초과하였습니다";
    GuideCheck_clover_coinStore_message_06 = "업그레이드 하시겠습니까?";
    Guide_clover_dialog_GameMission_03 = "{0}.lv";
    ErrorGuide_clover_020 = "골프 최종레벨에 도달하셨습니다";
    Guide_clover_CloverSale_01 = "구매 하시겠습니까?";


    Guide_clover_dialog_ExchangePage_01 = "플레타";
    Guide_clover_dialog_ExchangePage_02 = "엘뱅크-TRC20";
    Guide_clover_dialog_ExchangePage_03 = "은행";
    Guide_clover_dialog_ExchangePage_04 = "계좌번호";
    Guide_clover_dialog_ExchangePage_05 = "전송";
    Guide_clover_dialog_ExchangePage_06 = "취소";

    UserMarketErrorP_313 = "일 판매 가능 금액을 초과 하였습니다";
    UserMarketErrorE_201 = "이미 사용된 쿠폰 입니다";
    UserMarketErrorE_311 = "쿠폰 생성실패";
    UserMarketErrorA_101 = "사용 가능한 상품이 아닙니다";
    UserMarketErrorP_003 = "허용 가능 개수를 초과하였습니다";
    UserMarketErrorP_101 = "이미 존재하는 거래번호 입니다";
    UserMarketErrorP_102 = "존재하지 않는 거래번호 입니다";
    UserMarketErrorP_311 = "판매 가능 수량이 부족합니다";
    UserMarketErrorP_312 = "판매 가능 잔액이 부족합니다";


    DBTokenExchange_dialog_err_0 = "토큰 수량 확인이 필요합니다.";
    DBTokenExchange_dialog_err_1 = "잠시 후 다시 시도 해 주십시오.";
    DBTokenExchange_dialog_sucess = "환전 신청이 완료 되었습니다. \n 환전은 일정 시간이 소요됩니다.";




    RecommenderData = [];
    CheckRecommenderData = [];
    CompressedImageData = [];

    KrExcelData = [];
    EnExcelData = [];




    isSignUpButtonAction = false;
    isBool = false;
    NicknameCheckOK = false;
    ImageCheckOK = false;
    RecommenderCheckOK = false;
    isMainPage = false;
    isRecommenderPage = false;
    NicknameCheckButtonColor = false;
    RecommenderCheckButtonColor = false;
    isDBCoinTransferButton = 0;
    isMiningButton = 0;
    isUserProfileButton = 0;
    CloverCount = 0;








    constructor(root) {
        makeObservable(this, {
            loginState: observable,
            // RecommenderState:observable,
            isLogin: observable,
            loginFail: observable,
            isSignUpDialogOpen: observable,
            isCloverSaleDialogOpen: observable,
            SignUpImage: observable,
            SignUpNickname: observable,
            GuideImage: observable,
            GuideNickName: observable,
            GuideRecommender: observable,
            GuideNickNameColor: observable,
            GuideRecommenderColor: observable,
            CompressedImageData: observable,
            isSignUpButtonAction: observable,
            isBool: observable,
            CheckRecommenderData: observable,
            RecommenderData: observable,
            isWalletDialogOpen: observable,
            isCoinSendDialogOpen: observable,
            SignUpCommerce: observable,
            SignUpBusinessCode: observable,
            GuideNickNameLength: observable,
            NicknameCheckOK: observable,
            ImageCheckOK: observable,
            RecommenderCheckOK: observable,
            isMainPage: observable,
            isRecommenderPage: observable,
            NicknameCheckButtonColor: observable,
            RecommenderCheckButtonColor: observable,
            isMiningDialogOpen: observable,
            isMiningTransformDialogOpen: observable,
            isDBCoinTransferButton: observable,
            isUserProfileDialogOpen: observable,
            isUserProfileButton: observable,
            UserFrofileImageButtonColor: observable,
            CloverCount: observable,
            GuideProfileNicknameColor: observable,
            GuideProfileRecommender: observable,
            GuideProfileRecommenderColor: observable,
            isMiningButton: observable,
            isVerifyDialogOpen: observable,
            isAuthenticationDialogOpen: observable,
            isGameMissionDialogOpen: observable,
            Usercountry: observable,
            KrExcelData: observable,
            EnExcelData: observable,
            Guide_clover_profile: observable,
            Guide_clover_memberShip: observable,
            Guide_clover_memberImage_Button: observable,
            GuideLabel_clover_nickName: observable,
            GuideLabel_clover_recommender: observable,
            GuideSuccess_profileImage_size: observable,
            ErrorGuide_clover_profileImage_size: observable,
            Guide_clover_allPage_01: observable,
            Guide_clover_allPage_02: observable,
            Guide_clover_allPage_03: observable,
            Guide_clover_allPage_04: observable,
            Guide_clover_allPage_05: observable,
            Guide_clover_allPage_06: observable,
            Guide_clover_dialog_AuthenticationCheck_01: observable,
            Guide_clover_dialog_AuthenticationCheck_02: observable,
            Guide_clover_dialog_CoinSend_01: observable,
            Guide_clover_dialog_CoinSend_02: observable,
            Guide_clover_dialog_DBCoinTransfer_01: observable,
            Guide_clover_dialog_DBCoinTransfer_02: observable,
            Guide_clover_dialog_DBCoinTransfer_03: observable,
            Guide_clover_dialog_GameMission_01: observable,
            Guide_clover_dialog_GameMission_02: observable,
            Guide_clover_dialog_Mining_01: observable,
            Guide_clover_dialog_Mining_02: observable,
            Guide_clover_dialog_Mining_03: observable,
            Guide_clover_dialog_Mining_04: observable,
            Guide_clover_dialog_Mining_05: observable,
            Guide_clover_dialog_Mining_06: observable,
            Guide_clover_dialog_Mining_07: observable,
            Guide_clover_dialog_Mining_08: observable,
            Guide_clover_dialog_Mining_09: observable,
            Guide_clover_dialog_Mining_11: observable,
            Guide_clover_dialog_Mining_12: observable,
            Guide_clover_dialog_Mining_13: observable,
            Guide_clover_dialog_Mining_14: observable,
            Guide_clover_dialog_Mining_button_01: observable,
            Guide_clover_dialog_Mining_button_02: observable,
            Guide_clover_dialog_Mining_button_03: observable,
            Guide_clover_dialog_UserProfile_01: observable,
            Guide_clover_dialog_UserProfile_03: observable,
            Guide_clover_dialog_UserProfile_04: observable,
            Guide_clover_dialog_UserProfile_05: observable,
            Guide_clover_dialog_UserProfile_06: observable,
            Guide_clover_dialog_UserProfile_08: observable,
            Guide_clover_dialog_UserProfile_09: observable,
            Guide_clover_dialog_UserProfile_10: observable,
            Guide_clover_dialog_UserProfile_button_02: observable,
            Guide_clover_dialog_UserProfile_button_03: observable,
            Guide_clover_dialog_UserProfile_button_04: observable,
            Guide_clover_dialog_UserProfile_button_05: observable,
            Guide_clover_dialog_UserProfile_button_07: observable,
            Guide_clover_dialog_UserProfile_button_08: observable,
            Guide_clover_dialog_Verify_01: observable,
            Guide_clover_dialog_Verify_02: observable,
            Guide_clover_dialog_Verify_03: observable,
            Guide_clover_dialog_Verify_04: observable,
            Guide_clover_dialog_Walletinformation_01: observable,
            Guide_clover_page_CloverMissionBar_01: observable,
            Guide_clover_page_CloverMissionBar_02: observable,
            Guide_clover_page_CloverMissionBar_03: observable,
            Guide_clover_page_MissionPmgBar_01: observable,
            Guide_clover_page_MissionPmgBar_02: observable,
            Guide_clover_page_MissionPmgBar_03: observable,
            Guide_clover_page_MissionPmgBar_04: observable,
            Guide_clover_page_topBar_01: observable,
            Guide_clover_page_topBar_02: observable,
            Guide_clover_page_userBar_01: observable,
            Guide_clover_commission: observable,
            Guide_clover_userProfile_01: observable,
            Guide_clover_userProfile_02: observable,
            Guide_clover_userProfile_03: observable,
            Guide_clover_userProfile_04: observable,
            Guide_clover_userProfile_05: observable,
            ErrorGuide_clover_001: observable,
            ErrorGuide_clover_002: observable,
            ErrorGuide_clover_003: observable,
            ErrorGuide_clover_004: observable,
            ErrorGuide_clover_005: observable,
            ErrorGuide_clover_006: observable,
            ErrorGuide_clover_007: observable,
            ErrorGuide_clover_008: observable,
            ErrorGuide_clover_009: observable,
            ErrorGuide_clover_page_userBar_01: observable,
            ErrorGuide_clover_page_userBar_02: observable,
            ErrorGuide_clover_coin_001: observable,
            ErrorGuide_clover_coin_003: observable,
            ErrorGuide_clover_coin_004: observable,
            ErrorGuide_clover_coin_005: observable,
            ErrorGuide_clover_coin_006: observable,
            ErrorGuide_501: observable,
            ErrorGuide_810: observable,
            ErrorGuide_811: observable,
            ErrorGuide_812: observable,
            ErrorGuide_814: observable,
            ErrorGuide_813: observable,
            ErrorGuide_815: observable,
            ErrorGuide_2400: observable,
            ErrorGuide_3001: observable,
            ErrorGuide_3002: observable,
            ErrorGuide_3003: observable,
            ErrorGuide_3004: observable,
            ErrorGuide_3501: observable,
            ErrorGuide_3505: observable,
            ErrorGuide_3506: observable,
            ErrorGuide_3600: observable,
            ErrorGuide_3601: observable,
            ErrorGuide_clover_userProfile_01: observable,
            ErrorGuide_clover_userProfile_02: observable,
            ErrorGuide_clover_userProfile_03: observable,
            ErrorGuide_clover_userProfile_04: observable,
            ErrorGuide_clover_userProfile_05: observable,
            ErrorGuide_clover_userProfile_06: observable,
            ErrorGuide_clover_userProfile_07: observable,
            ErrorGuide_clover_userProfile_08: observable,
            Guid_recommender_confirm: observable,
            SuccessGuide_message: observable,
            SuccessGuide_nickName_check: observable,
            ErrorGuide_clover_010: observable,
            ErrorGuide_3602: observable,
            Guide_clover_dialog_Verify_05: observable,
            Guide_clover_dialog_Mining_button_04: observable,
            GuideLabel_clover_dialog_UserProfile_01: observable,
            Guide_clover_dialog_UserProfile_11: observable,
            GuideCheck_clover_coinStore_message_01: observable,
            GuideCheck_clover_coinStore_message_02: observable,
            GuideCheck_clover_coinStore_message_03: observable,
            GuideCheck_clover_coinStore_message_04: observable,
            GuideCheck_clover_coinStore_message_05: observable,
            ErrorGuide_3700: observable,
            ErrorGuide_3701: observable,
            ErrorGuide_3702: observable,
            ErrorGuide_3703: observable,
            GuideCheck_clover_coinStore_message_06: observable,
            Guide_clover_dialog_GameMission_03: observable,
            ErrorGuide_clover_020: observable,
            Guide_clover_dialog_CloverSale_01: observable,
            isCloverMarketDialogOpen: observable,
            isCloverMarketProductDialogOpen: observable,
            Guide_clover_CloverSale_01: observable,
            isCoinExchangeProposeDialogOpen: observable,
            isCloverMarketCouponitemDialogOpen: observable,

            Guide_clover_dialog_ExchangePage_01: observable,
            Guide_clover_dialog_ExchangePage_02: observable,
            Guide_clover_dialog_ExchangePage_03: observable,
            Guide_clover_dialog_ExchangePage_04: observable,
            Guide_clover_dialog_ExchangePage_05: observable,
            Guide_clover_dialog_ExchangePage_06: observable,
            UserMarketErrorP_313: observable,
            UserMarketErrorE_201: observable,
            UserMarketErrorE_311: observable,
            UserMarketErrorA_101: observable,
            UserMarketErrorP_003: observable,
            UserMarketErrorP_101: observable,
            UserMarketErrorP_102: observable,
            UserMarketErrorP_311: observable,
            UserMarketErrorP_312: observable,
            isCloverLockPageDialogOpen: observable,

            DBTokenExchange_dialog_err_0: observable,
            DBTokenExchange_dialog_err_1: observable,
            DBTokenExchange_dialog_sucess: observable,










            setCloverLockPageDialogOpen: action,
            setCloverMarketCouponitemDialogOpen: action,
            setCoinExchangeProposeDialogOpen: action,
            setCloverMarketProductDialogOpen: action,
            setCloverMarketDialogOpen: action,
            setAllLoginCall: action,
            setCloverSaleDialogOpen: action,
            setUserOverseas: action,
            setTestLoginInfo: action,
            setOverseasLogin: action,
            getipChack: action,
            setGameMissionDialogOpen: action,
            setAuthenticationDialogOpen: action,
            setUserProfileRefresh: action,
            setIsVerifyDialogOpen: action,
            setDBMiningButton: action,
            setGuideProfileRecommenderColor: action,
            setGuideProfileNicknameColor: action,
            setGuideProfileNickname: action,
            getCloverCount: action,
            setCloverCount: action,
            setUpDateRecommender: action,
            setUpDateNickname: action,
            setUserImageButtonColor: action,
            setUserprofileButton: action,
            setUserProfileDialogOpen: action,
            setUpDateImage: action,
            setImageChange: action,
            setDBCoinTransferButton: action,
            setIsMiningTransformDialogOpen: action,
            setIsMiningDialogOpen: action,
            setRecommenderCheckButtonColor: action,
            setNicknameCheckButtonColor: action,
            SignUpRefresh: action,
            setIsMainPage: action,
            setIsRecommenderPage: action,
            setIsCoinSendDialogOpen: action,
            setIsWalletDialogOpen: action,
            setIsSignUpDialogOpen: action,
            setRecommenderData: action,
            setGuideRecommender: action,
            setGuideRecommenderColor: action,
            setGuideImage: action,
            setSignUpRecommender: action,
            setCheckRecommender: action,
            setSignUpButton: action,
            setGuideNickNameColor: action,
            setGuideNickName: action,
            setSignUp: action,
            setCheckNickName: action,
            setSignUpNickname: action,
            setUserImage: action,
            setSignUpImage: action,
            LoginTest: action,
            getAceesToken: action,
            setLoginStore: action,
            setLoginFail: action,
            setIsLogin: action,
            logOut: action,
        });

        this.rootStore = root;
        this.CoinStore = this.rootStore;


        this.isLogin = getSession("isLogin", false);
        this.loginState = getSessionJson('userInfo') ? new LoginState(getSessionJson('userInfo'), null) : new LoginState();
        // this.RecommenderState = getSessionJson('RecommenderInfo') ? new RecommenderState(getSessionJson('RecommenderInfo')) : new RecommenderState();



        this.loginFail = false;
        this.isSignUpDialogOpen = false;
        this.isWalletDialogOpen = false;
        this.isCoinSendDialogOpen = false;
        this.isMiningDialogOpen = false;
        this.isMiningTransformDialogOpen = false;
        this.isUserProfileDialogOpen = false;
        this.isVerifyDialogOpen = false;
        this.isAuthenticationDialogOpen = false;
        this.isGameMissionDialogOpen = false;
        this.isCloverSaleDialogOpen = false;
        this.isCloverMarketDialogOpen = false;
        this.isCloverMarketProductDialogOpen = false;
        this.isCloverMarketCouponitemDialogOpen = false;
        this.isCoinExchangeProposeDialogOpen = false;
        this.isCloverLockPageDialogOpen = false;







        this.Usercountry = "";

        this.SignUpImage = '';
        this.SignUpNickname = '';
        this.SignUpCommerce = '';
        this.SignUpBusinessCode = '';



        this.Guide_clover_memberShip = "회원가입"; //확인
        this.Guide_clover_profile = "프로필 사진 등록"; //확인
        this.Guide_clover_memberImage_Button = "등록";// 확인
        this.GuideLabel_clover_nickName = "닉네임";// 확인
        this.GuideLabel_clover_recommender = "추천인"; //확인


        this.GuideSuccess_profileImage_size = '프로필 사진 등록 완료';// 확인


        this.ErrorGuide_clover_profileImage_size = '첨부파일 사이즈는 2.5MB 이내로 등록 가능합니다';// 확인




        this.GuideNickName = '중복 체크 해주세요';
        this.GuideNickNameLength = '';
        this.GuideNickNameColor = 'red';
        this.GuideProfileNicknameColor = "#fc0000";
        this.UserFrofileImageButtonColor = "#4fc3f7";
        this.NicknameCheckButtonColor = false;
        this.GuideImage = '프로필 사진을 등록 해주세요';
        this.GuideRecommenderColor = 'blue';
        this.GuideRecommender = '검색해주세요';
        this.Guide_clover_profileNickname_count = "1000소모"; //확인
        this.GuideProfileRecommender = '검색해주세요';
        this.GuideProfileRecommenderColor = 'blue';

        this.Guide_clover_allPage_01 = "지갑주소를 입력해주세요";
        this.Guide_clover_allPage_02 = "수량을 입력해 주세요";
        this.Guide_clover_allPage_03 = "수수료확인";
        this.Guide_clover_allPage_04 = "개인정보 수집 이용 동의";
        this.Guide_clover_allPage_05 = "보내기";
        this.Guide_clover_allPage_06 = "회";
        this.Guide_clover_dialog_AuthenticationCheck_01 = "My.동의";
        this.Guide_clover_dialog_AuthenticationCheck_02 = "본인 인증을 위한 개인정보 수집 · 이용 및 제공, 위탁 동의서 \n 개인정보 보호법에 따라 (주)SoftBrain에 인증을 요청하시는 분께 \n 수집하는 개인정보의 항목, 개인정보의 수집 및 이용목적, 개인정보의 보유 및 이용기간, 동의 거부권 및 동의 거부 시 \n 불이익에 관한 사항을 안내 드리오니 자세히 읽은 후 동의하여 주시기 바랍니다. \n 1. 개인정보의 수집 및 이용목적 \n 서비스 이용시 이용자로부터 수집하는 개인정보는 아래와 같습니다. \n -회원정보 또는 개별 서비스에서 프로필 정보 ( 닉네임, 프로필 사진 )를 설정할 수 있습니다. \n 2. 수집하려는 개인정보의 항목 \n -인증 요청 시에 '휴대전화번호,이메일 주소'를 필수항목으로 수집합니다. \n 3.개인정보의 보유 및 이용기간 \n - 부정 가입 및 이용 방지 \n 탈퇴한 이용자의 휴대전화번호 : 탈퇴일로부터 6개월 보관 \n 4. 개인정보 수집 및 이용 동의를 거부할 권리 \n 이용자는 개인정보의 수집 및 이용 동의를 거부할 권리가 있습니다. \n 회원가입 시 수집하는 최소한의 개인정보, 즉, 필수 항목에 대한 수집 및 이용 동의를 거부하실 경우, 인증 요청이 어려울 수 있습니다";
        this.Guide_clover_dialog_CoinSend_01 = "My.코인 이체";
        this.Guide_clover_dialog_CoinSend_02 = "My. 지갑";
        this.Guide_clover_dialog_DBCoinTransfer_01 = "코인 전환";
        this.Guide_clover_dialog_DBCoinTransfer_02 = "All";
        this.Guide_clover_dialog_DBCoinTransfer_03 = "수수료";
        this.Guide_clover_dialog_GameMission_01 = "My.게임미션";
        this.Guide_clover_dialog_GameMission_02 = "MAX";
        this.Guide_clover_dialog_Mining_01 = "채굴";
        this.Guide_clover_dialog_Mining_02 = "시간";
        this.Guide_clover_dialog_Mining_03 = "분";
        this.Guide_clover_dialog_Mining_04 = "초";
        this.Guide_clover_dialog_Mining_05 = "비용";
        this.Guide_clover_dialog_Mining_06 = "진행 중";
        this.Guide_clover_dialog_Mining_07 = "남은 정보";
        this.Guide_clover_dialog_Mining_08 = "보유";
        this.Guide_clover_dialog_Mining_09 = "채굴 정보";
        this.Guide_clover_dialog_Mining_11 = "수령 가능";
        this.Guide_clover_dialog_Mining_12 = "종류";
        this.Guide_clover_dialog_Mining_13 = "수량";
        this.Guide_clover_dialog_Mining_14 = "날짜";
        this.Guide_clover_dialog_Mining_button_01 = "수령";
        this.Guide_clover_dialog_Mining_button_02 = "내역";
        this.Guide_clover_dialog_Mining_button_03 = "채굴시작";
        this.Guide_clover_dialog_UserProfile_01 = "프로필";
        this.Guide_clover_dialog_UserProfile_03 = "my class";
        this.Guide_clover_dialog_UserProfile_04 = "Class.";
        this.Guide_clover_dialog_UserProfile_05 = "명의 추천인을 받을 수 있습니다.";
        this.Guide_clover_dialog_UserProfile_06 = "인증 완료 되었습니다";
        this.Guide_clover_dialog_UserProfile_08 = "소모";
        this.Guide_clover_dialog_UserProfile_09 = "추천대상자가 미션을 완수하면";
        this.Guide_clover_dialog_UserProfile_10 = "보상은 받습니다";
        this.Guide_clover_dialog_UserProfile_button_02 = "친구";
        this.Guide_clover_dialog_UserProfile_button_03 = "등급";
        this.Guide_clover_dialog_UserProfile_button_04 = "팔로잉";
        this.Guide_clover_dialog_UserProfile_button_05 = "팔로워";
        this.Guide_clover_dialog_UserProfile_button_07 = "인증 하기";
        this.Guide_clover_dialog_UserProfile_button_08 = "class 업";
        this.Guide_clover_dialog_Verify_01 = "My.인증";
        this.Guide_clover_dialog_Verify_02 = "번호확인";
        this.Guide_clover_dialog_Verify_03 = "인증확인";
        this.Guide_clover_dialog_Verify_04 = "전화번호를 입력해 주세요";
        this.Guide_clover_dialog_CloverSale_01 = "My.판매";
        this.Guide_clover_dialog_CloverSale_02 = "구매";
        this.Guide_clover_dialog_Walletinformation_01 = "My.지갑";
        this.Guide_clover_page_CloverMissionBar_01 = "Mission";
        this.Guide_clover_page_CloverMissionBar_02 = "업그레이드! 클릭";
        this.Guide_clover_page_CloverMissionBar_03 = "Limit";
        this.Guide_clover_page_MissionPmgBar_01 = "play";
        this.Guide_clover_page_MissionPmgBar_02 = "클릭해서 리워드를 /n 받으세요.";
        this.Guide_clover_page_MissionPmgBar_03 = "보상을 받으셨습니다";
        this.Guide_clover_page_MissionPmgBar_04 = "후 도전 가능";
        this.Guide_clover_page_topBar_01 = "Clover";
        this.Guide_clover_page_topBar_02 = "Login & join";
        this.Guide_clover_page_userBar_01 = "복사 하였습니다";
        this.Guide_clover_commission = "확인을 눌러 주세요";
        this.Guide_clover_userProfile_01 = "추천인 목록이 없습니다";
        this.Guide_clover_userProfile_02 = "친구 목록이 없습니다";
        this.Guide_clover_userProfile_03 = "팔로우 목록이 없습니다";
        this.Guide_clover_userProfile_04 = "인증확인 되었습니다";
        this.Guide_clover_userProfile_05 = "인증완료 되었습니다";
        this.ErrorGuide_clover_001 = "새로고침을 시도해주세요";
        this.ErrorGuide_clover_002 = "최종레벨에 도달 하셨습니다";
        this.ErrorGuide_clover_003 = "팡팡 최종레벨에 도달하셨습니다";
        this.ErrorGuide_clover_004 = "큐브 최종레벨에 도달하셨습니다";
        this.ErrorGuide_clover_005 = "코인이 부족합니다";
        this.ErrorGuide_clover_006 = "수수료가 차이가 있을 수 있습니다!";
        this.ErrorGuide_clover_007 = "지갑정보를 입력해주세요";
        this.ErrorGuide_clover_008 = "코인수량을 입력해주세요";
        this.ErrorGuide_clover_009 = "수량을 확인해주세요";
        this.ErrorGuide_clover_page_userBar_01 = "복사에 실패하였습니다";
        this.ErrorGuide_clover_page_userBar_02 = "복사하기가 지원되지 않는 브라우저입니다";
        this.ErrorGuide_clover_coin_001 = "지갑주소를 확인해주세요";
        this.ErrorGuide_clover_coin_003 = "지갑주소를 찾을 수 없습니다";
        this.ErrorGuide_clover_coin_004 = "거래소 정보를 불러 올 수 없습니다";
        this.ErrorGuide_clover_coin_005 = "코인 전송에 실패하였습니다";
        this.ErrorGuide_clover_coin_006 = "수수료가 부족합니다";
        this.ErrorGuide_501 = "잠시 후 다시 시도해주세요";
        this.ErrorGuide_810 = "중복입니다 다시 체크 해주세요";
        this.ErrorGuide_811 = "빈칸입니다 다시 체크 해주세요";
        this.ErrorGuide_812 = "특수문자는 닉네임으로 할 수 없습니다";
        this.ErrorGuide_814 = "클로버가 부족합니다";
        this.ErrorGuide_813 = "2글자 이상 20글자 미만으로 해주세요";
        this.ErrorGuide_815 = "닉네임에  욕설은 포함될수 없습니다";
        this.ErrorGuide_2400 = "클로버 구매를 실패하였습니다";
        this.ErrorGuide_3001 = "해당 유저를 찾을수 없습니다";
        this.ErrorGuide_3002 = "해당 유저의 추천인 등록 수가 최대치 입니다";
        this.ErrorGuide_3003 = "이미추천인을 등록하셨습니다";
        this.ErrorGuide_3004 = "자신을 추천인으로 등록 할 수 없습니다";
        this.ErrorGuide_3501 = "채굴정보가 없습니다";
        this.ErrorGuide_3505 = "완료된 채굴이 없습니다";
        this.ErrorGuide_3506 = "최대50회까지 가능합니다";
        this.ErrorGuide_3600 = "금일 미션이 완료 되었습니다";
        this.ErrorGuide_3601 = "플레이 횟수가 모자랍니다";
        this.ErrorGuide_clover_userProfile_01 = "유저를 찾을 수 없습니다";
        this.ErrorGuide_clover_userProfile_02 = "등급이 해당되지 않습니다";
        this.ErrorGuide_clover_userProfile_03 = "다음 레벨을 찾을 수 없습니다";
        this.ErrorGuide_clover_userProfile_04 = "다시 확인 해주세요";
        this.ErrorGuide_clover_userProfile_05 = "추천인이 없습니다";
        this.ErrorGuide_clover_userProfile_06 = "정보를 찾을 수 없습니다";
        this.ErrorGuide_clover_userProfile_07 = "추천인이 친구 리스트를 공유 하지 않습니다";
        this.ErrorGuide_clover_userProfile_08 = "추천인이 친구로 등록한 사람이 없습니다";
        this.Guid_recommender_confirm = "추천인을 확인해주세요";
        this.SuccessGuide_message = "완료되셨습니다";
        this.SuccessGuide_nickName_check = "체크 완료입니다";
        this.ErrorGuide_clover_010 = "이더리움이 부족합니다";
        this.ErrorGuide_3602 = "완료 할 수 없는 미션입니다";
        this.Guide_clover_dialog_Verify_05 = "인증번호를 입력해 주세요";
        this.Guide_clover_dialog_Mining_button_04 = "소요 시간";
        this.GuideLabel_clover_dialog_UserProfile_01 = "친구 공유";
        this.Guide_clover_dialog_UserProfile_11 = "{0}명 +";
        this.GuideCheck_clover_coinStore_message_01 = "보내시겠습니까?";
        this.GuideCheck_clover_coinStore_message_02 = "취소되었습니다";
        this.GuideCheck_clover_coinStore_message_03 = "닉네임을 등록 하시겠습니까?";
        this.GuideCheck_clover_coinStore_message_04 = "추천인을 등록 하시겠습니까?";
        this.GuideCheck_clover_coinStore_message_05 = "친구를 복사하시겠습니까?";
        this.ErrorGuide_3700 = "휴대전화 번호를 확인해 주세요.";
        this.ErrorGuide_3701 = "잘못된 코드 이거나 입력 시간이 초과 되었습니다.";
        this.ErrorGuide_3702 = "이미 인증 완료 되었습니다.";
        this.ErrorGuide_3703 = "금일 전송가능 문자개수를 초과하였습니다";
        this.GuideCheck_clover_coinStore_message_06 = "업그레이드 하시겠습니까?";
        this.Guide_clover_dialog_GameMission_03 = "{0}.lv";
        this.ErrorGuide_clover_020 = "골프 최종레벨에 도달하셨습니다";
        this.Guide_clover_CloverSale_01 = "구매 하시겠습니까?";

        this.Guide_clover_dialog_ExchangePage_01 = "플레타";
        this.Guide_clover_dialog_ExchangePage_02 = "엘뱅크-TRC20";
        this.Guide_clover_dialog_ExchangePage_03 = "은행";
        this.Guide_clover_dialog_ExchangePage_04 = "계좌번호";
        this.Guide_clover_dialog_ExchangePage_05 = "전송";
        this.Guide_clover_dialog_ExchangePage_06 = "취소";

        this.UserMarketErrorP_313 = "일 판매 가능 금액을 초과 하였습니다";
        this.UserMarketErrorE_201 = "이미 사용된 쿠폰 입니다";
        this.UserMarketErrorE_311 = "쿠폰 생성실패";
        this.UserMarketErrorA_101 = "사용 가능한 상품이 아닙니다";
        this.UserMarketErrorP_003 = "허용 가능 개수를 초과하였습니다";
        this.UserMarketErrorP_101 = "이미 존재하는 거래번호 입니다";
        this.UserMarketErrorP_102 = "존재하지 않는 거래번호 입니다";
        this.UserMarketErrorP_311 = "판매 가능 수량이 부족합니다";
        this.UserMarketErrorP_312 = "판매 가능 잔액이 부족합니다";



        this.DBTokenExchange_dialog_err_0 = "토큰 수량 확인이 필요합니다.";
        this.DBTokenExchange_dialog_err_1 = "잠시 후 다시 시도 해 주십시오.";

        this.DBTokenExchange_dialog_sucess = "환전 신청이 완료 되었습니다. \n 환전은 일정 시간이 소요됩니다.";







        this.RecommenderData = [];
        this.CheckRecommenderData = [];
        this.CompressedImageData = [];

        this.KrExcelData = [];
        this.EnExcelData = [];


        this.isSignUpButtonAction = false;
        this.isBool = false;
        this.NicknameCheckOK = false;
        this.ImageCheckOK = false;
        this.RecommenderCheckOK = false;
        this.isMainPage = false;
        this.isRecommenderPage = false;
        this.RecommenderCheckButtonColor = false;
        this.isDBCoinTransferButton = 0;
        this.isMiningButton = 0;
        this.isUserProfileButton = 0;
        this.CloverCount = 0;
        this.MissionPmgBarButton = 0;
        this.MissionCagButton = 0;



    }

    async getAceesToken(callback) {
        var api = "/auth/silent-refresh";
        this.setIsMainPage(false);
        this.setIsRecommenderPage(false);
        await post({ api: api, data: {} }, async (err, response) => {
            if (err) {
                clearAll();
                return callback(err, null);
            } else {
                if (response?.data?.result?.accessToken) {
                    setBearer(`Bearer ${response?.data?.result?.accessToken}`);
                    api = '/login';
                    await privatePost({ api: api, data: {} }, async (err, response) => {
                        if (err) {
                            return callback(err, null)
                        } else {
                            if (response?.data?.result) {
                                this.setIsMainPage(true);
                                this.setIsLogin(true);
                                this.setLoginStore(response?.data?.result);
                                this.rootStore.UserProfileStore.getRecommenderInfo("LOGININ");
                                this.rootStore.MissionStore.getUserMissionCount("Login");
                                this.setAllLoginCall();
                                // this.rootStore.MissionStore.getUserMissionLevelInfo("Login");
                                // this.rootStore.MissionStore.getUserMissionLevelInfo("Login");
                                const CloverCount = this.CloverCount;
                                if (response?.data?.result?.phone_no !== undefined || response?.data?.result?.phone_no !== null || response?.data?.result?.phone_no !== "") {
                                    this.rootStore.UserProfileStore.setregistVerify(true);
                                }
                                else {
                                    this.rootStore.UserProfileStore.setregistVerify(false);
                                }
                                if (response?.data?.result?.clover_count !== CloverCount) {
                                    this.getCloverCount();
                                }
                                if (response?.data?.result?.member_nickname === null || response?.data?.result?.member_nickname === undefined || response?.data?.result.member_nickname === "") {
                                    this.setDialogOpen("SignUp");//기존 닉네임 체크 없으면 닉네임 등록창 오픈
                                }
                                return callback(null, true)
                            } else {
                                this.setIsMainPage(false);
                                this.setLoginStore();
                                this.setLoginFail(true);
                                return callback(true, null)
                            }
                        }
                    });
                } else {
                    this.setIsMainPage(false);
                    this.setLoginStore();
                    this.setLoginFail(true);
                    return callback(true, null)
                }
            }
        });
    };

    async silentLogin(data, callback) {
        var api = "/silenceLogin";
        this.setIsMainPage(false);
        this.setIsRecommenderPage(false);
        await post({ api: api, data: data }, async (err, response) => {
            if (err) {
                clearAll();
                return callback(err, null);
            } else {
                if (response?.data?.result?.accessToken) {
                    setBearer(`Bearer ${response?.data?.result?.accessToken}`);
                    if (response?.data?.result) {
                        this.setIsMainPage(true);
                        this.setIsLogin(true);
                        this.setLoginStore(response?.data?.result);
                        this.rootStore.UserProfileStore.getRecommenderInfo("LOGININ");
                        this.rootStore.MissionStore.getUserMissionCount("Login");
                        this.setAllLoginCall();
                        const CloverCount = this.CloverCount;
                        if (response?.data?.result?.phone_no !== undefined || response?.data?.result?.phone_no !== null || response?.data?.result?.phone_no !== "") {
                            this.rootStore.UserProfileStore.setregistVerify(true);
                        }
                        else {
                            this.rootStore.UserProfileStore.setregistVerify(false);
                        }
                        if (response?.data?.result?.clover_count !== CloverCount) {
                            this.getCloverCount();
                        }
                        if (response?.data?.result?.member_nickname === null || response?.data?.result?.member_nickname === undefined || response?.data?.result.member_nickname === "") {
                            this.setDialogOpen("SignUp");//기존 닉네임 체크 없으면 닉네임 등록창 오픈
                        }
                        return callback(null, true)
                    }
                } else {
                    this.setIsMainPage(false);
                    this.setLoginStore();
                    this.setLoginFail(true);
                    return callback(true, null)
                }
            }
        });
    };

    LoginTest = () => {//테스트 로그인 
        setBearer(`Bearer1`);
        const api = '/login';
        this.setIsMainPage(false);
        // console.log("LiginStart");
        this.setIsRecommenderPage(false);
        privatePost({ api: api, data: { email_address: "anduf0502@gmail.com" } }, (err, response) => {
            // console.log("LoginIn");
            if (err) {
                // console.log(err);
                this.setIsMainPage(false);
            }
            else {
                if (response?.data?.result) {
                    // console.log(response?.data?.result);
                    const CloverCount = this.CloverCount;
                    this.setIsLogin(true);
                    this.setIsMainPage(true);
                    // this.setOverseasLogin(this.Usercountry); // 해외 유저 체크
                    this.setTestLoginInfo()
                    this.setLoginStore(response?.data?.result);
                    this.rootStore.UserProfileStore.getRecommenderInfo("LOGININ");
                    this.rootStore.MissionStore.getUserMissionCount("Login");
                    this.setAllLoginCall();
                    // this.rootStore.MissionStore.getUserMissionLevelInfo("Login", "Amount");
                    // console.log("IN");
                    // this.getipChack();
                    if (response?.data?.result?.phone_no !== undefined || response?.data?.result?.phone_no !== null || response?.data?.result?.phone_no !== "") {
                        this.rootStore.UserProfileStore.setregistVerify(true);
                    }
                    else {
                        this.rootStore.UserProfileStore.setregistVerify(false);
                    }
                    if (response?.data?.result?.clover_count !== CloverCount) {
                        this.getCloverCount();
                    }
                    if (response?.data?.result.member_nickname === undefined || response?.data?.result.member_nickname === null || response?.data?.result.member_nickname === "") {
                        this.setDialogOpen("SignUp");//기존 닉네임 체크 없으면 닉네임 등록창 오픈
                    }
                    // if (this.Usercountry) {
                    //     this.setOverseasLogin(this.Usercountry); // 해외 유저 체크
                    // }
                }
            }
        });
    };


    setAllLoginCall() {
        // console.log("LoginAllCall");
        // this.rootStore?.MissionStore?.getUserMissionLevelInfo("OPEN", "Amount");
    }

    setOverseasLogin(UsercountryCode) {
        // console.log("UsercountryCode", UsercountryCode);
        // console.log(this.Usercountry);
        if (UsercountryCode !== "KR") {
            // console.log("US");
            this.setUserOverseas("US");// 해외 자동 유저 만들기 !! 
        }
        else {
            // console.log("KRture");
        }

    }

    setUserOverseas(Check) {
        // console.log("setUserOverseas",Check);
        const api = '/getUserOverseasRecommender';
        let UserOverseasData = {
            member_no: this.loginState.member_no
        }

        if (Check === "US") {
            privatePost({ api: api, data: UserOverseasData }, (err, response) => {
                // console.log("1");
                if (err) {
                    // console.log("err", err);
                    if (err.errorCode === 501) {//추천인 에러 처리
                        return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                    }
                    else if (err.errorCode === 3001) {
                        return alert(this.ErrorGuide_3001);//해당 유저를 찾을수 없습니다
                    }
                    else if (err.errorCode === 3002) {
                        return alert(this.ErrorGuide_3002);//해당 유저의 추천인 등록 수가 최대치 입니다
                    }
                    else if (err.errorCode === 3003) {
                        return alert(this.ErrorGuide_3003);//이미추천인을 등록하셨습니다
                    }
                    else if (err.errorCode === 3004) {
                        return alert(this.ErrorGuide_3004);//자신을 추천인으로 등록 할 수 없습니다
                    }
                    else {
                        return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                    }
                }
                else {
                    // console.log("UserData", response);
                    if (response?.data?.result) {
                        this.setRecommenderData(response?.data?.result);
                        this.setSignUpButton(true);
                        this.rootStore.UserProfileStore.getRecommenderInfo();
                    }
                }
                // this.Usercountry = UserData;
            })
        }
    }

    setTestLoginInfo() {
        // this.setDialogOpen("SignUp");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("Wallet");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("CoinSend");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("MiningTransform");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("Mining");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("UserProfile");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("Verify");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("Authentication");// TEST 확인용 평소 주석 처리
        // this.setDialogOpen("GameMission");// TEST 확인용 평소 주석 처리
    }


    getipChack(Usercountry) {

        // console.log(Usercountry);
        this.Usercountry = Usercountry;

        let Language = [];


        if (language.length) {
            Language = language;
            // console.log("IN", Language);
            for (let i = 0; i < Language.length; i++) {
                // console.log(i);
                // console.log("count", Language[i]);
                // if(Language[i].Code !== "") {
                // this.Usercountry "US"
                if (Usercountry === "KR" || Usercountry === null || Usercountry === undefined) {
                    // console.log(Language[i].Code === "Guide_clover_profileNickname_count");
                    if (Language[i].Code === "Guide_clover_profileNickname_count") {
                        this.Guide_clover_profileNickname_count = Language[i].kr // 1000소모
                    }
                    else if (Language[i].Code === "Guide_clover_profile") {
                        this.Guide_clover_profile = Language[i].kr //프로필 사진 등록
                    }
                    else if (Language[i].Code === "Guide_clover_memberShip") {
                        this.Guide_clover_memberShip = Language[i].kr //회원가입
                    }
                    else if (Language[i].Code === "Guide_clover_memberImage_Button") {
                        this.Guide_clover_memberImage_Button = Language[i].kr //등록
                    }
                    else if (Language[i].Code === "GuideLabel_clover_nickName") {
                        this.GuideLabel_clover_nickName = Language[i].kr //닉네임
                    }
                    else if (Language[i].Code === "GuideLabel_clover_recommender") {
                        this.GuideLabel_clover_recommender = Language[i].kr //추천인
                    }
                    else if (Language[i].Code === "GuideSuccess_profileImage_size") {
                        this.GuideSuccess_profileImage_size = Language[i].kr //프로필 사진 등록 완료
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_profileImage_size") {
                        this.ErrorGuide_clover_profileImage_size = Language[i].kr //첨부파일 사이즈는 2.5MB 이내로 등록 가능합니다
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_01") {
                        this.Guide_clover_allPage_01 = Language[i].kr //지갑주소를 입력해주세요
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_02") {
                        this.Guide_clover_allPage_02 = Language[i].kr //수량을 입력해 주세요
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_03") {
                        this.Guide_clover_allPage_03 = Language[i].kr //수수료확인
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_04") {
                        this.Guide_clover_allPage_04 = Language[i].kr //개인정보 수집 이용 동의
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_05") {
                        this.Guide_clover_allPage_05 = Language[i].kr //보내기
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_06") {
                        this.Guide_clover_allPage_06 = Language[i].kr //회
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_AuthenticationCheck_01") {
                        this.Guide_clover_dialog_AuthenticationCheck_01 = Language[i].kr //My.동의
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_AuthenticationCheck_02") {
                        this.Guide_clover_dialog_AuthenticationCheck_02 = Language[i].kr //동의서 내용 길어
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CoinSend_01") {
                        this.Guide_clover_dialog_CoinSend_01 = Language[i].kr //My.코인 이체
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CoinSend_02") {
                        this.Guide_clover_dialog_CoinSend_02 = Language[i].kr //My. 지갑
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_DBCoinTransfer_01") {
                        this.Guide_clover_dialog_DBCoinTransfer_01 = Language[i].kr //코인 전환
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_DBCoinTransfer_02") {
                        this.Guide_clover_dialog_DBCoinTransfer_02 = Language[i].kr //All
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_DBCoinTransfer_03") {
                        this.Guide_clover_dialog_DBCoinTransfer_03 = Language[i].kr //수수료
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_GameMission_01") {
                        this.Guide_clover_dialog_GameMission_01 = Language[i].kr //My.게임미션
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_GameMission_02") {
                        this.Guide_clover_dialog_GameMission_02 = Language[i].kr //MAX
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_01") {
                        this.Guide_clover_dialog_Mining_01 = Language[i].kr //채굴
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_02") {
                        this.Guide_clover_dialog_Mining_02 = Language[i].kr //시간
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_03") {
                        this.Guide_clover_dialog_Mining_03 = Language[i].kr //분
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_04") {
                        this.Guide_clover_dialog_Mining_04 = Language[i].kr //초
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_05") {
                        this.Guide_clover_dialog_Mining_05 = Language[i].kr //비용
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_06") {
                        this.Guide_clover_dialog_Mining_06 = Language[i].kr //진행 중
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_07") {
                        this.Guide_clover_dialog_Mining_07 = Language[i].kr //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_08") {
                        this.Guide_clover_dialog_Mining_08 = Language[i].kr //보유
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_09") {
                        this.Guide_clover_dialog_Mining_09 = Language[i].kr //채굴 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_11") {
                        this.Guide_clover_dialog_Mining_11 = Language[i].kr //수령 가능
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_12") {
                        this.Guide_clover_dialog_Mining_12 = Language[i].kr //종류
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_13") {
                        this.Guide_clover_dialog_Mining_13 = Language[i].kr //수량
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_14") {
                        this.Guide_clover_dialog_Mining_14 = Language[i].kr //날짜
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_01") {
                        this.Guide_clover_dialog_Mining_button_01 = Language[i].kr //수령
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_02") {
                        this.Guide_clover_dialog_Mining_button_02 = Language[i].kr //내역
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_03") {
                        this.Guide_clover_dialog_Mining_button_03 = Language[i].kr //채굴시작
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_01") {
                        this.Guide_clover_dialog_UserProfile_01 = Language[i].kr //프로필
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_03") {
                        this.Guide_clover_dialog_UserProfile_03 = Language[i].kr //my class
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_04") {
                        this.Guide_clover_dialog_UserProfile_04 = Language[i].kr //Class.
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_05") {
                        this.Guide_clover_dialog_UserProfile_05 = Language[i].kr //명의 추천인을 받을 수 있습니다.
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_06") {
                        this.Guide_clover_dialog_UserProfile_06 = Language[i].kr //인증 완료 되었습니다
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_08") {
                        this.Guide_clover_dialog_UserProfile_08 = Language[i].kr //소모
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_09") {
                        this.Guide_clover_dialog_UserProfile_09 = Language[i].kr //추천대상자가 미션을 완수하면
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_10") {
                        this.Guide_clover_dialog_UserProfile_10 = Language[i].kr //보상은 받습니다
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_02") {
                        this.Guide_clover_dialog_UserProfile_button_02 = Language[i].kr //친구
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_03") {
                        this.Guide_clover_dialog_UserProfile_button_03 = Language[i].kr //등급
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_04") {
                        this.Guide_clover_dialog_UserProfile_button_04 = Language[i].kr //팔로잉
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_05") {
                        this.Guide_clover_dialog_UserProfile_button_05 = Language[i].kr //팔로워
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_07") {
                        this.Guide_clover_dialog_UserProfile_button_07 = Language[i].kr //인증 하기
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_08") {
                        this.Guide_clover_dialog_UserProfile_button_08 = Language[i].kr //class 업
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_01") {
                        this.Guide_clover_dialog_Verify_01 = Language[i].kr //My.인증
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_02") {
                        this.Guide_clover_dialog_Verify_02 = Language[i].kr //번호확인
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_03") {
                        this.Guide_clover_dialog_Verify_03 = Language[i].kr //인증확인
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_04") {
                        this.Guide_clover_dialog_Verify_04 = Language[i].kr //전화번호를 입력해 주세요
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Walletinformation_01") {
                        this.Guide_clover_dialog_Walletinformation_01 = Language[i].kr //My.지갑
                    }
                    else if (Language[i].Code === "Guide_clover_page_CloverMissionBar_01") {
                        this.Guide_clover_page_CloverMissionBar_01 = Language[i].kr //Mission
                    }
                    else if (Language[i].Code === "Guide_clover_page_CloverMissionBar_02") {
                        this.Guide_clover_page_CloverMissionBar_02 = Language[i].kr //업그레이드! 클릭
                    }
                    else if (Language[i].Code === "Guide_clover_page_CloverMissionBar_03") {
                        this.Guide_clover_page_CloverMissionBar_03 = Language[i].kr //Limit
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_01") {
                        this.Guide_clover_page_MissionPmgBar_01 = Language[i].kr //play
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_02") {
                        this.Guide_clover_page_MissionPmgBar_02 = Language[i].kr //클릭해서 리워드를 /n 받으세요.
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_03") {
                        this.Guide_clover_page_MissionPmgBar_03 = Language[i].kr //보상을 받으셨습니다
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_04") {
                        this.Guide_clover_page_MissionPmgBar_04 = Language[i].kr //후 도전 가능
                    }
                    else if (Language[i].Code === "Guide_clover_page_topBar_01") {
                        this.Guide_clover_page_topBar_01 = Language[i].kr //Clover
                    }
                    else if (Language[i].Code === "Guide_clover_page_topBar_02") {
                        this.Guide_clover_page_topBar_02 = Language[i].kr //Login & join
                    }
                    else if (Language[i].Code === "Guide_clover_page_userBar_01") {
                        this.Guide_clover_page_userBar_01 = Language[i].kr //복사 하였습니다
                    }
                    else if (Language[i].Code === "Guide_clover_commission") {
                        this.Guide_clover_commission = Language[i].kr //확인을 눌러 주세요
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_01") {
                        this.Guide_clover_userProfile_01 = Language[i].kr //추천인 목록이 없습니다
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_02") {
                        this.Guide_clover_userProfile_02 = Language[i].kr //친구 목록이 없습니다
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_03") {
                        this.Guide_clover_userProfile_03 = Language[i].kr //팔로우 목록이 없습니다
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_04") {
                        this.Guide_clover_userProfile_04 = Language[i].kr //인증확인 되었습니다
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_05") {
                        this.Guide_clover_userProfile_05 = Language[i].kr //인증완료 되었습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_001 ") {
                        this.ErrorGuide_clover_001 = Language[i].kr //새로고침을 시도해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_002 ") {
                        this.ErrorGuide_clover_002 = Language[i].kr //최종레벨에 도달 하셨습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_003 ") {
                        this.ErrorGuide_clover_003 = Language[i].kr //팡팡 최종레벨에 도달하셨습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_004 ") {
                        this.ErrorGuide_clover_004 = Language[i].kr //큐브 최종레벨에 도달하셨습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_005 ") {
                        this.ErrorGuide_clover_005 = Language[i].kr //코인이 부족합니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_006 ") {
                        this.ErrorGuide_clover_006 = Language[i].kr //수수료가 차이가 있을 수 있습니다!
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_007 ") {
                        this.ErrorGuide_clover_007 = Language[i].kr //지갑정보를 입력해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_008 ") {
                        this.ErrorGuide_clover_008 = Language[i].kr //코인수량을 입력해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_009 ") {
                        this.ErrorGuide_clover_009 = Language[i].kr //수량을 확인해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_page_userBar_01 ") {
                        this.ErrorGuide_clover_page_userBar_01 = Language[i].kr //복사에 실패하였습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_page_userBar_02 ") {
                        this.ErrorGuide_clover_page_userBar_02 = Language[i].kr //복사하기가 지원되지 않는 브라우저입니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_001  ") {
                        this.ErrorGuide_clover_coin_001 = Language[i].kr //지갑주소를 확인해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_003  ") {
                        this.ErrorGuide_clover_coin_003 = Language[i].kr //지갑주소를 찾을 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_004  ") {
                        this.ErrorGuide_clover_coin_004 = Language[i].kr //거래소 정보를 불러 올 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_005  ") {
                        this.ErrorGuide_clover_coin_005 = Language[i].kr //코인 전송에 실패하였습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_006  ") {
                        this.ErrorGuide_clover_coin_006 = Language[i].kr //수수료가 부족합니다
                    }
                    else if (Language[i].Code === "ErrorGuide_501  ") {
                        this.ErrorGuide_501 = Language[i].kr //잠시 후 다시 시도해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_810  ") {
                        this.ErrorGuide_810 = Language[i].kr //중복입니다 다시 체크 해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_811  ") {
                        this.ErrorGuide_811 = Language[i].kr //빈칸입니다 다시 체크 해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_812  ") {
                        this.ErrorGuide_812 = Language[i].kr //특수문자는 닉네임으로 할 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_814  ") {
                        this.ErrorGuide_814 = Language[i].kr //클로버가 부족합니다
                    }
                    else if (Language[i].Code === "ErrorGuide_813  ") {
                        this.ErrorGuide_813 = Language[i].kr //2글자 이상 20글자 미만으로 해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_815  ") {
                        this.ErrorGuide_815 = Language[i].kr //닉네임에  욕설은 포함될수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_2400  ") {
                        this.ErrorGuide_2400 = Language[i].kr //클로버 구매를 실패하였습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3001  ") {
                        this.ErrorGuide_3001 = Language[i].kr //해당 유저를 찾을수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3002  ") {
                        this.ErrorGuide_3002 = Language[i].kr //해당 유저의 추천인 등록 수가 최대치 입니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3003  ") {
                        this.ErrorGuide_3003 = Language[i].kr //이미추천인을 등록하셨습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3004  ") {
                        this.ErrorGuide_3004 = Language[i].kr //자신을 추천인으로 등록 할 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3501  ") {
                        this.ErrorGuide_3501 = Language[i].kr //채굴정보가 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3505  ") {
                        this.ErrorGuide_3505 = Language[i].kr //완료된 채굴이 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3506  ") {
                        this.ErrorGuide_3506 = Language[i].kr //최대50회까지 가능합니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3600  ") {
                        this.ErrorGuide_3600 = Language[i].kr //금일 미션이 완료 되었습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3601  ") {
                        this.ErrorGuide_3601 = Language[i].kr //플레이 횟수가 모자랍니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_01  ") {
                        this.ErrorGuide_clover_userProfile_01 = Language[i].kr //유저를 찾을 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_02  ") {
                        this.ErrorGuide_clover_userProfile_02 = Language[i].kr //등급이 해당되지 않습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_03  ") {
                        this.ErrorGuide_clover_userProfile_03 = Language[i].kr //다음 레벨을 찾을 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_04  ") {
                        this.ErrorGuide_clover_userProfile_04 = Language[i].kr //다시 확인 해주세요
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_05  ") {
                        this.ErrorGuide_clover_userProfile_05 = Language[i].kr //추천인이 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_06  ") {
                        this.ErrorGuide_clover_userProfile_06 = Language[i].kr //정보를 찾을 수 없습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_07  ") {
                        this.ErrorGuide_clover_userProfile_07 = Language[i].kr //추천인이 친구 리스트를 공유 하지 않습니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_08  ") {
                        this.ErrorGuide_clover_userProfile_08 = Language[i].kr //추천인이 친구로 등록한 사람이 없습니다
                    }
                    else if (Language[i].Code === "Guid_recommender_confirm  ") {
                        this.Guid_recommender_confirm = Language[i].kr //추천인을 확인해주세요
                    }
                    else if (Language[i].Code === "SuccessGuide_message   ") {
                        this.SuccessGuide_message = Language[i].kr //완료되셨습니다
                    }
                    else if (Language[i].Code === "SuccessGuide_nickName_check   ") {
                        this.SuccessGuide_nickName_check = Language[i].kr //체크 완료입니다
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_010") {
                        this.ErrorGuide_clover_010 = Language[i].kr //이더리움이 부족합니다
                    }
                    else if (Language[i].Code === "ErrorGuide_3602") {
                        this.ErrorGuide_3602 = Language[i].kr //완료 할 수 없는 미션입니다
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_05") {
                        this.Guide_clover_dialog_Verify_05 = Language[i].kr //인증번호를 입력해 주세요
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_04") {
                        this.Guide_clover_dialog_Mining_button_04 = Language[i].kr //소요 시간
                    }
                    else if (Language[i].Code === "GuideLabel_clover_dialog_UserProfile_01") {
                        this.GuideLabel_clover_dialog_UserProfile_01 = Language[i].kr //친구 공유
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_11") {
                        this.Guide_clover_dialog_UserProfile_11 = Language[i].kr //{0}명 +
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_01") {
                        this.GuideCheck_clover_coinStore_message_01 = Language[i].kr //보내시겠습니까?
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_02") {
                        this.GuideCheck_clover_coinStore_message_02 = Language[i].kr //취소되었습니다
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_03") {
                        this.GuideCheck_clover_coinStore_message_03 = Language[i].kr //닉네임을 등록 하시겠습니까?
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_04") {
                        this.GuideCheck_clover_coinStore_message_04 = Language[i].kr //추천인을 등록 하시겠습니까?
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_05") {
                        this.GuideCheck_clover_coinStore_message_05 = Language[i].kr //친구를 복사하시겠습니까?
                    }
                    else if (Language[i].Code === "ErrorGuide_3700") {
                        this.ErrorGuide_3700 = Language[i].kr //휴대전화 번호를 확인해 주세요.
                    }
                    else if (Language[i].Code === "ErrorGuide_3701") {
                        this.ErrorGuide_3701 = Language[i].kr //잘못된 코드 이거나 입력 시간이 초과 되었습니다.
                    }
                    else if (Language[i].Code === "ErrorGuide_3702") {
                        this.ErrorGuide_3702 = Language[i].kr //이미 인증 완료 되었습니다.
                    }
                    else if (Language[i].Code === "ErrorGuide_3703") {
                        this.ErrorGuide_3703 = Language[i].kr //금일 전송가능 문자개수를 초과하였습니다
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_06") {
                        this.GuideCheck_clover_coinStore_message_06 = Language[i].kr //업그레이드 하시겠습니까?
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_GameMission_03") {
                        this.Guide_clover_dialog_GameMission_03 = Language[i].kr //{0}.lv
                    }
                    else if (Language[i].Code === "GuideNickName") {
                        this.GuideNickName = Language[i].kr //중복 체크 해주세요
                    }
                    else if (Language[i].Code === "GuideImage") {
                        this.GuideImage = Language[i].kr //프로필 사진을 등록 해주세요
                    }
                    else if (Language[i].Code === "GuideRecommender") {
                        this.GuideRecommender = Language[i].kr //검색해주세요
                        this.GuideProfileRecommender = Language[i].kr;
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_020") {
                        this.ErrorGuide_clover_020 = Language[i].kr //골프 최종레벨에 도달하셨습니다
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CloverSale_01") {
                        this.Guide_clover_dialog_CloverSale_01 = Language[i].kr //My.판매 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CloverSale_02") {
                        this.Guide_clover_dialog_CloverSale_02 = Language[i].kr //구매 
                    }
                    else if (Language[i].Code === "Guide_clover_CloverSale_01") {
                        this.Guide_clover_CloverSale_01 = Language[i].kr //구매 하시겠습니까? 
                    }

                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_01 ") {
                        this.Guide_clover_dialog_ExchangePage_01 = Language[i].kr //플레타 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_02") {
                        this.Guide_clover_dialog_ExchangePage_02 = Language[i].kr //엘벵크-TRC20 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_03") {
                        this.Guide_clover_dialog_ExchangePage_03 = Language[i].kr //은행 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_04") {
                        this.Guide_clover_dialog_ExchangePage_04 = Language[i].kr //계좌번호 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_05") {
                        this.Guide_clover_dialog_ExchangePage_05 = Language[i].kr //전송 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_06") {
                        this.Guide_clover_dialog_ExchangePage_06 = Language[i].kr //취소 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_313 ") {
                        this.UserMarketErrorP_313 = Language[i].kr //일 판매 가능 금액을 초과 하였습니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorE_201") {
                        this.UserMarketErrorE_201 = Language[i].kr //이미 사용된 쿠폰 입니다
                    }
                    else if (Language[i].Code === "UserMarketErrorE_311") {
                        this.UserMarketErrorE_311 = Language[i].kr //쿠폰 생성실패 
                    }
                    else if (Language[i].Code === "UserMarketErrorA_101") {
                        this.UserMarketErrorA_101 = Language[i].kr //사용 가능한 상품이 아닙니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_003") {
                        this.UserMarketErrorP_003 = Language[i].kr //허용 가능 개수를 초과하였습니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_101") {
                        this.UserMarketErrorP_101 = Language[i].kr //이미 존재하는 거래번호 입니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_102") {
                        this.UserMarketErrorP_102 = Language[i].kr //존재하지 않는 거래번호 입니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_311") {
                        this.UserMarketErrorP_311 = Language[i].kr //판매 가능 수량이 부족합니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_312") {
                        this.UserMarketErrorP_312 = Language[i].kr //판매 가능 잔액이 부족합니다 
                    }
                    else if (Language[i].Code === "DBTokenExchange_dialog_err_0") {
                        this.DBTokenExchange_dialog_err_0 = Language[i].kr //
                    }
                    else if (Language[i].Code === "DBTokenExchange_dialog_err_1") {
                        this.DBTokenExchange_dialog_err_1 = Language[i].kr //
                    }
                    else if (Language[i].Code === "DBTokenExchange_dialog_sucess") {
                        this.DBTokenExchange_dialog_sucess = Language[i].kr //
                    }
                    



                }
                else {
                    if (Language[i].Code === "Guide_clover_profileNickname_count") {
                        this.Guide_clover_profileNickname_count = Language[i].us
                    }
                    else if (Language[i].Code === "Guide_clover_profile") {
                        this.Guide_clover_profile = Language[i].us
                    }
                    else if (Language[i].Code === "Guide_clover_memberShip") {
                        this.Guide_clover_memberShip = Language[i].us
                    }
                    else if (Language[i].Code === "Guide_clover_memberImage_Button") {
                        this.Guide_clover_memberImage_Button = Language[i].us
                    }
                    else if (Language[i].Code === "GuideLabel_clover_nickName") {
                        this.GuideLabel_clover_nickName = Language[i].us
                    }
                    else if (Language[i].Code === "GuideLabel_clover_recommender") {
                        this.GuideLabel_clover_recommender = Language[i].us
                    }
                    else if (Language[i].Code === "GuideSuccess_profileImage_size") {
                        this.GuideSuccess_profileImage_size = Language[i].us //프로필 사진 등록 완료
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_profileImage_size") {
                        this.ErrorGuide_clover_profileImage_size = Language[i].us //첨부파일 사이즈는 2.5MB 이내로 등록 가능합니다
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_01") {
                        this.Guide_clover_allPage_01 = Language[i].us //지갑주소를 입력해주세요
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_02") {
                        this.Guide_clover_allPage_02 = Language[i].us //수량을 입력해 주세요
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_03") {
                        this.Guide_clover_allPage_03 = Language[i].us //수수료확인
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_04") {
                        this.Guide_clover_allPage_04 = Language[i].us //개인정보 수집 이용 동의
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_05") {
                        this.Guide_clover_allPage_05 = Language[i].us //보내기
                    }
                    else if (Language[i].Code === "Guide_clover_allPage_06") {
                        this.Guide_clover_allPage_06 = Language[i].us //회
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_AuthenticationCheck_01") {
                        this.Guide_clover_dialog_AuthenticationCheck_01 = Language[i].us //My.동의
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_AuthenticationCheck_02") {
                        this.Guide_clover_dialog_AuthenticationCheck_02 = Language[i].us //동의서 내용 길어
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CoinSend_01") {
                        this.Guide_clover_dialog_CoinSend_01 = Language[i].us //My.코인 이체
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CoinSend_02") {
                        this.Guide_clover_dialog_CoinSend_02 = Language[i].us //My. 지갑
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_DBCoinTransfer_01") {
                        this.Guide_clover_dialog_DBCoinTransfer_01 = Language[i].us //코인 전환
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_DBCoinTransfer_02") {
                        this.Guide_clover_dialog_DBCoinTransfer_02 = Language[i].us //All
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_DBCoinTransfer_03") {
                        this.Guide_clover_dialog_DBCoinTransfer_03 = Language[i].us //수수료
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_GameMission_01") {
                        this.Guide_clover_dialog_GameMission_01 = Language[i].us //My.게임미션
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_GameMission_02") {
                        this.Guide_clover_dialog_GameMission_02 = Language[i].us //MAX
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_01") {
                        this.Guide_clover_dialog_Mining_01 = Language[i].us //채굴
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_02") {
                        this.Guide_clover_dialog_Mining_02 = Language[i].us //시간
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_03") {
                        this.Guide_clover_dialog_Mining_03 = Language[i].us //분
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_04") {
                        this.Guide_clover_dialog_Mining_04 = Language[i].us //초
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_05") {
                        this.Guide_clover_dialog_Mining_05 = Language[i].us //비용
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_06") {
                        this.Guide_clover_dialog_Mining_06 = Language[i].us //진행 중
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_07") {
                        this.Guide_clover_dialog_Mining_07 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_08") {
                        this.Guide_clover_dialog_Mining_08 = Language[i].us //보유
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_09") {
                        this.Guide_clover_dialog_Mining_09 = Language[i].us //채굴 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_11") {
                        this.Guide_clover_dialog_Mining_11 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_12") {
                        this.Guide_clover_dialog_Mining_12 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_13") {
                        this.Guide_clover_dialog_Mining_13 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_14") {
                        this.Guide_clover_dialog_Mining_14 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_01") {
                        this.Guide_clover_dialog_Mining_button_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_02") {
                        this.Guide_clover_dialog_Mining_button_02 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_03") {
                        this.Guide_clover_dialog_Mining_button_03 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_01") {
                        this.Guide_clover_dialog_UserProfile_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_03") {
                        this.Guide_clover_dialog_UserProfile_03 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_04") {
                        this.Guide_clover_dialog_UserProfile_04 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_05") {
                        this.Guide_clover_dialog_UserProfile_05 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_06") {
                        this.Guide_clover_dialog_UserProfile_06 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_08") {
                        this.Guide_clover_dialog_UserProfile_08 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_09") {
                        this.Guide_clover_dialog_UserProfile_09 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_10") {
                        this.Guide_clover_dialog_UserProfile_10 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_02") {
                        this.Guide_clover_dialog_UserProfile_button_02 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_03") {
                        this.Guide_clover_dialog_UserProfile_button_03 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_04") {
                        this.Guide_clover_dialog_UserProfile_button_04 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_05") {
                        this.Guide_clover_dialog_UserProfile_button_05 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_07") {
                        this.Guide_clover_dialog_UserProfile_button_07 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_button_08") {
                        this.Guide_clover_dialog_UserProfile_button_08 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_01") {
                        this.Guide_clover_dialog_Verify_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_02") {
                        this.Guide_clover_dialog_Verify_02 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_03") {
                        this.Guide_clover_dialog_Verify_03 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_04") {
                        this.Guide_clover_dialog_Verify_04 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Walletinformation_01") {
                        this.Guide_clover_dialog_Walletinformation_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_CloverMissionBar_01") {
                        this.Guide_clover_page_CloverMissionBar_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_CloverMissionBar_02") {
                        this.Guide_clover_page_CloverMissionBar_02 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_CloverMissionBar_03") {
                        this.Guide_clover_page_CloverMissionBar_03 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_01") {
                        this.Guide_clover_page_MissionPmgBar_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_02") {
                        this.Guide_clover_page_MissionPmgBar_02 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_03") {
                        this.Guide_clover_page_MissionPmgBar_03 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_MissionPmgBar_04") {
                        this.Guide_clover_page_MissionPmgBar_04 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_topBar_01") {
                        this.Guide_clover_page_topBar_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_topBar_02") {
                        this.Guide_clover_page_topBar_02 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_page_userBar_01") {
                        this.Guide_clover_page_userBar_01 = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_commission") {
                        this.Guide_clover_commission = Language[i].us //남은 정보
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_01") {
                        this.Guide_clover_userProfile_01 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_02") {
                        this.Guide_clover_userProfile_02 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_03") {
                        this.Guide_clover_userProfile_03 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_04") {
                        this.Guide_clover_userProfile_04 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guide_clover_userProfile_05") {
                        this.Guide_clover_userProfile_05 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_001") {
                        this.ErrorGuide_clover_001 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_002") {
                        this.ErrorGuide_clover_002 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_003") {
                        this.ErrorGuide_clover_003 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_004") {
                        this.ErrorGuide_clover_004 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_005") {
                        this.ErrorGuide_clover_005 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_006") {
                        this.ErrorGuide_clover_006 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_007") {
                        this.ErrorGuide_clover_007 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_008") {
                        this.ErrorGuide_clover_008 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_009") {
                        this.ErrorGuide_clover_009 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_page_userBar_01") {
                        this.ErrorGuide_clover_page_userBar_01 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_page_userBar_02") {
                        this.ErrorGuide_clover_page_userBar_02 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_001") {
                        this.ErrorGuide_clover_coin_001 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_003") {
                        this.ErrorGuide_clover_coin_003 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_004") {
                        this.ErrorGuide_clover_coin_004 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_005") {
                        this.ErrorGuide_clover_coin_005 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_coin_006") {
                        this.ErrorGuide_clover_coin_006 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_501") {
                        this.ErrorGuide_501 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_810") {
                        this.ErrorGuide_810 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_811") {
                        this.ErrorGuide_811 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_812") {
                        this.ErrorGuide_812 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_814") {
                        this.ErrorGuide_814 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_813") {
                        this.ErrorGuide_813 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_815") {
                        this.ErrorGuide_815 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_2400") {
                        this.ErrorGuide_2400 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3001") {
                        this.ErrorGuide_3001 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3002") {
                        this.ErrorGuide_3002 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3003") {
                        this.ErrorGuide_3003 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3004") {
                        this.ErrorGuide_3004 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3501") {
                        this.ErrorGuide_3501 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3505") {
                        this.ErrorGuide_3505 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3506") {
                        this.ErrorGuide_3506 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3600") {
                        this.ErrorGuide_3600 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3601") {
                        this.ErrorGuide_3601 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_01") {
                        this.ErrorGuide_clover_userProfile_01 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_02") {
                        this.ErrorGuide_clover_userProfile_02 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_03") {
                        this.ErrorGuide_clover_userProfile_03 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_04") {
                        this.ErrorGuide_clover_userProfile_04 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_05") {
                        this.ErrorGuide_clover_userProfile_05 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_06") {
                        this.ErrorGuide_clover_userProfile_06 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_07") {
                        this.ErrorGuide_clover_userProfile_07 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_userProfile_08") {
                        this.ErrorGuide_clover_userProfile_08 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guid_recommender_confirm") {
                        this.Guid_recommender_confirm = Language[i].us //
                    }
                    else if (Language[i].Code === "SuccessGuide_message") {
                        this.SuccessGuide_message = Language[i].us //
                    }
                    else if (Language[i].Code === "SuccessGuide_nickName_check") {
                        this.SuccessGuide_nickName_check = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_010") {
                        this.ErrorGuide_clover_010 = Language[i].us //
                    }
                    else if (Language[i].Code === "ErrorGuide_3602") {
                        this.ErrorGuide_3602 = Language[i].us //
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Verify_05") {
                        this.Guide_clover_dialog_Verify_05 = Language[i].us //인증번호를 입력해 주세요
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_Mining_button_04") {
                        this.Guide_clover_dialog_Mining_button_04 = Language[i].us //소요 시간
                    }
                    else if (Language[i].Code === "GuideLabel_clover_dialog_UserProfile_01") {
                        this.GuideLabel_clover_dialog_UserProfile_01 = Language[i].us //친구 공유
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_UserProfile_11") {
                        this.Guide_clover_dialog_UserProfile_11 = Language[i].us //{0}명 +
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_01") {
                        this.GuideCheck_clover_coinStore_message_01 = Language[i].us //보내시겠습니까?
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_02") {
                        this.GuideCheck_clover_coinStore_message_02 = Language[i].us //취소되었습니다
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_03") {
                        this.GuideCheck_clover_coinStore_message_03 = Language[i].us //닉네임을 등록 하시겠습니까?
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_04") {
                        this.GuideCheck_clover_coinStore_message_04 = Language[i].us //추천인을 등록 하시겠습니까?
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_05") {
                        this.GuideCheck_clover_coinStore_message_05 = Language[i].us //친구를 복사하시겠습니까?
                    }
                    else if (Language[i].Code === "ErrorGuide_3700") {
                        this.ErrorGuide_3700 = Language[i].us //휴대전화 번호를 확인해 주세요.
                    }
                    else if (Language[i].Code === "ErrorGuide_3701") {
                        this.ErrorGuide_3701 = Language[i].us //잘못된 코드 이거나 입력 시간이 초과 되었습니다.
                    }
                    else if (Language[i].Code === "ErrorGuide_3702") {
                        this.ErrorGuide_3702 = Language[i].us //이미 인증 완료 되었습니다.
                    }
                    else if (Language[i].Code === "ErrorGuide_3703") {
                        this.ErrorGuide_3703 = Language[i].us //금일 전송가능 문자개수를 초과하였습니다
                    }
                    else if (Language[i].Code === "GuideCheck_clover_coinStore_message_06") {
                        this.GuideCheck_clover_coinStore_message_06 = Language[i].us //업그레이드 하시겠습니까?
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_GameMission_03") {
                        this.Guide_clover_dialog_GameMission_03 = Language[i].us //{0}.lv
                    }
                    else if (Language[i].Code === "GuideNickName") {
                        this.GuideNickName = Language[i].us //중복 체크 해주세요
                    }
                    else if (Language[i].Code === "GuideImage") {
                        this.GuideImage = Language[i].us //프로필 사진을 등록 해주세요
                    }
                    else if (Language[i].Code === "GuideRecommender") {
                        this.GuideRecommender = Language[i].us //검색해주세요
                        this.GuideProfileRecommender = Language[i].us;
                    }
                    else if (Language[i].Code === "ErrorGuide_clover_020") {
                        this.ErrorGuide_clover_020 = Language[i].us //골프 최종레벨에 도달하셨습니다
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CloverSale_01") {
                        this.Guide_clover_dialog_CloverSale_01 = Language[i].us //My.판매
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_CloverSale_02") {
                        this.Guide_clover_dialog_CloverSale_02 = Language[i].us //구매 
                    }
                    else if (Language[i].Code === "Guide_clover_CloverSale_01") {
                        this.Guide_clover_CloverSale_01 = Language[i].us //구매 
                    }

                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_01 ") {
                        this.Guide_clover_dialog_ExchangePage_01 = Language[i].us //플레타 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_02") {
                        this.Guide_clover_dialog_ExchangePage_02 = Language[i].us //엘벵크-TRC20 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_03") {
                        this.Guide_clover_dialog_ExchangePage_03 = Language[i].us //은행 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_04") {
                        this.Guide_clover_dialog_ExchangePage_04 = Language[i].us //계좌번호 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_05") {
                        this.Guide_clover_dialog_ExchangePage_05 = Language[i].us //전송 
                    }
                    else if (Language[i].Code === "Guide_clover_dialog_ExchangePage_06") {
                        this.Guide_clover_dialog_ExchangePage_06 = Language[i].us //취소 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_313 ") {
                        this.UserMarketErrorP_313 = Language[i].us //일 판매 가능 금액을 초과 하였습니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorE_201") {
                        this.UserMarketErrorE_201 = Language[i].us //이미 사용된 쿠폰 입니다
                    }
                    else if (Language[i].Code === "UserMarketErrorE_311") {
                        this.UserMarketErrorE_311 = Language[i].us //쿠폰 생성실패 
                    }
                    else if (Language[i].Code === "UserMarketErrorA_101") {
                        this.UserMarketErrorA_101 = Language[i].us //사용 가능한 상품이 아닙니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_003") {
                        this.UserMarketErrorP_003 = Language[i].us //허용 가능 개수를 초과하였습니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_101") {
                        this.UserMarketErrorP_101 = Language[i].us //이미 존재하는 거래번호 입니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_102") {
                        this.UserMarketErrorP_102 = Language[i].us //존재하지 않는 거래번호 입니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_311") {
                        this.UserMarketErrorP_311 = Language[i].us //판매 가능 수량이 부족합니다 
                    }
                    else if (Language[i].Code === "UserMarketErrorP_312") {
                        this.UserMarketErrorP_312 = Language[i].us //판매 가능 잔액이 부족합니다 
                    }
                    else if (Language[i].Code === "DBTokenExchange_dialog_err_0") {
                        this.DBTokenExchange_dialog_err_0 = Language[i].us //
                    }
                    else if (Language[i].Code === "DBTokenExchange_dialog_err_1") {
                        this.DBTokenExchange_dialog_err_1 = Language[i].us //
                    }
                    else if (Language[i].Code === "DBTokenExchange_dialog_sucess") {
                        this.DBTokenExchange_dialog_sucess = Language[i].us //
                    }
                }
                // }
            }
        }
        this.rootStore.CoinStore.CoinStoreTestCheck("ININ");


    }





    setDBCoinTransferButton = (value) => {
        if (value === 0) {
            this.isDBCoinTransferButton = 0;
        }
        else if (value === 1) {
            this.isDBCoinTransferButton = 1;
        }

    }

    setDBMiningButton = (value) => {
        if (value === 0) {
            this.rootStore.MiningStore.setMiningDialogReset();
            this.rootStore.MiningStore.getMimingItemList("Button0");
            this.isMiningButton = 0;
        }
        else if (value === 1) {
            this.rootStore.MiningStore.getUserMiningList("Button1");
            this.isMiningButton = 1;
        }
        else if (value === 2) {
            this.rootStore.MiningStore.getMiningHistory();
            this.isMiningButton = 2;
        }
    }

    setUserprofileButton = (value) => {
        if (value === 0) {
            this.isUserProfileButton = 0;
        }
        else if (value === 1) {
            // console.log("buttonChangeStart");
            this.isUserProfileButton = 1;
            this.rootStore.UserProfileStore.getFriendCount("GOI");
            // this.rootStore.UserProfileStore.getUserFollowerList();
            // this.rootStore.UserProfileStore.getUserFriendRecommenderList();

        }
        else if (value === 2) {
            this.isUserProfileButton = 2;
        }
    }

    setDialogOpen = (value) => {
        // console.log("setDialogOpen", value);
        // const CoinStore = this.CoinStore.CoinStore;
        if (value === "SignUp") {
            this.setIsSignUpDialogOpen(true);
            this.SignUpRefresh();
            const Existing_nickname = this.loginState.member_nickname;
            if (Existing_nickname === undefined || Existing_nickname === null || Existing_nickname === "") {
                this.setSignUpButton(false);
            }
            else {
                this.setSignUpButton(true);
            }
        }
        else if (value === "Wallet") {
            this.setIsWalletDialogOpen(true);
            this.rootStore.CoinStore.getMemberLockTokenData("PageIn");
            this.rootStore.CoinStore.getExchangeCommissionWithWallet();
        }
        else if (value === "CoinSend") {
            this.setIsCoinSendDialogOpen(true);
            this.rootStore.CoinStore.CoinSendRefrash();
        }
        else if (value === "MiningTransform") {
            this.setIsMiningTransformDialogOpen(true);
            this.rootStore.CoinStore.setisDBCoinTransfer("DBCoinTransfer", true);
            // return alert("준비중입니다");
        }
        else if (value === "Mining") {
            this.setIsMiningDialogOpen(true);
            this.rootStore.MiningStore.setMiningDialogReset();
            // return alert("준비중입니다");
        }
        else if (value === "UserProfile") {
            this.setUserProfileDialogOpen(true);
            this.rootStore.UserProfileStore.getRecommenderInfo("IN");
        }
        else if (value === "Verify") {
            this.setIsVerifyDialogOpen(true);;
        }
        else if (value === "Authentication") {
            this.setAuthenticationDialogOpen(true);
        }
        else if (value === "GameMission") {
            this.setGameMissionDialogOpen(true);
            this.rootStore?.MissionStore?.getUserMissionLevelInfo("OPEN", "Amount");
        }
        else if (value === "CloverSale") {//클로버셀
            this.setCloverSaleDialogOpen(true);
            this.rootStore?.SaleStore?.getCloverCountKRW("CloverSaleDialog");
        }
        else if (value === "CloverMarket") {//마켓
            this.setCloverMarketDialogOpen(true);
            this.rootStore?.SaleStore?.getMarketPLData("CloverMarketDialog");
        }
        else if (value === "CloverMarketProduct") {//마켓상품
            this.setCloverMarketProductDialogOpen(true);
        }
        else if (value === "CoinExchangePropose") {//코인 환전 신고
            this.setCoinExchangeProposeDialogOpen(true);
        }
        else if (value === "CloverMarketCouponitem") {//마켓 쿠폰
            this.setCloverMarketCouponitemDialogOpen(true);
        }
        else if (value === "CloverMarketCouponitem") {//마켓 쿠폰
            this.setCloverMarketCouponitemDialogOpen(true);
        }
        else if (value === "CloverLock") {// lock token view page\
            // this.rootStore.CoinStore.getMemberLockTokenData("Page");
            this.setCloverLockPageDialogOpen(true);
        }

    }

    setDialogClose = (value) => {
        // console.log(value);
        if (value === "SignupFalse") {
            this.setIsSignUpDialogOpen(false);
        }
        else if (value === "WalletFalse") {
            this.setIsWalletDialogOpen(false);
        }
        else if (value === "CoinSendFalse") {
            this.setIsCoinSendDialogOpen(false);
        }
        else if (value === "MiningTransformFalse") {
            this.setIsMiningTransformDialogOpen(false);
            // return alert("준비중입니다");
        }
        else if (value === "MiningFalse") {
            this.setIsMiningDialogOpen(false);
            // return alert("준비중입니다");
        }
        else if (value === "UserProfileFalse") {
            this.setUserProfileDialogOpen(false);
        }
        else if (value === "VerifyFalse") {

            this.setIsVerifyDialogOpen(false);
        }
        else if (value === "AuthenticationFalse") {
            this.setAuthenticationDialogOpen(false);
        }
        else if (value === "GameMissionFalse") {
            this.setGameMissionDialogOpen(false);
        }
        else if (value === "CloverSaleFalse") {//클로버셀
            this.setCloverSaleDialogOpen(false);
        }
        else if (value === "CloverMarketFalse") {//마켓
            this.setCloverMarketDialogOpen(false);
            this.rootStore?.SaleStore?.setResetMarket();
        }
        else if (value === "CloverMarketProductFalse") {//마켓상품
            this.setCloverMarketProductDialogOpen(false);
            // this.rootStore?.SaleStore?.setResetMarket();
        }
        else if (value === "CoinExchangeProposeFalse") {//코인 환전 신고
            this.setCoinExchangeProposeDialogOpen(false);
        }
        else if (value === "CloverMarketCouponitemFalse") {//마켓 쿠폰
            this.setCloverMarketCouponitemDialogOpen(false);
        }
        else if (value === "CloverLockPageFalse") {// lock token view page
            this.setCloverLockPageDialogOpen(false);
        }
        else if (value === "AllFalse") {
            this.setUserProfileDialogOpen(false);
            this.setIsMiningDialogOpen(false);
            this.setIsCoinSendDialogOpen(false);
            this.setIsWalletDialogOpen(false);
            this.setGameMissionDialogOpen(false);
            this.setIsMiningTransformDialogOpen(false);
            this.setCoinExchangeProposeDialogOpen(false);
            this.setCloverMarketDialogOpen(false);
            this.setCloverMarketProductDialogOpen(false);
            this.setCloverSaleDialogOpen(false);
        }
        // this.isCloverMarketProductDialogOpen = false;
    }


    setIsSignUpDialogOpen(bool) {
        this.isSignUpDialogOpen = bool;
    }

    setIsWalletDialogOpen(bool) {
        this.isWalletDialogOpen = bool;
    }

    setIsCoinSendDialogOpen(bool) {
        this.isCoinSendDialogOpen = bool;
    }

    setIsMiningTransformDialogOpen(bool) {
        this.isMiningTransformDialogOpen = bool;
        // return alert("준비중입니다");
    }

    setIsMiningDialogOpen(bool) {
        this.isMiningDialogOpen = bool;
        // return alert("준비중입니다");
    }

    setUserProfileDialogOpen(bool) {
        // console.log(bool);
        this.isUserProfileDialogOpen = bool;
        // eslint-disable-next-line
        if (bool == false) {
            this.setUserProfileRefresh();
        }

    }

    setUserProfileRefresh() {
        this.isUserProfileButton = 0;
    }

    setIsVerifyDialogOpen(bool) {
        this.isVerifyDialogOpen = bool;
    }

    setAuthenticationDialogOpen(bool) {
        this.isAuthenticationDialogOpen = bool;
    }


    setGameMissionDialogOpen(bool) {
        this.isGameMissionDialogOpen = bool;
    }

    setCloverSaleDialogOpen(bool) {
        this.isCloverSaleDialogOpen = bool;
    }

    setCloverMarketDialogOpen(bool) {
        // console.log(bool);
        this.isCloverMarketDialogOpen = bool;
        // this.rootStore.SaleStore.setisUserMarket();
    }

    setCloverMarketProductDialogOpen(bool) {
        this.isCloverMarketProductDialogOpen = bool;
    }

    setCoinExchangeProposeDialogOpen(bool) {
        this.isCoinExchangeProposeDialogOpen = bool;

    }

    setCloverMarketCouponitemDialogOpen(bool) {
        this.isCloverMarketCouponitemDialogOpen = bool;
    }

    setCloverLockPageDialogOpen(bool) {
        // console.log("PageIn", bool);
        this.isCloverLockPageDialogOpen = bool;
    }

    setUserImage(base64) {//보여주기 이미지 
        this.SignUpImage = base64;
        this.ImageCheckOK = true;
    };

    setGuideImage(value) {
        this.GuideImage = value;
    }





    setSignUpImage = async (input) => {
        const fileType = input.target.files[0].type;
        const fileSize = input.target.files[0].size;
        const maxSize = 2.5 * 1024 * 1024;
        const inputImage = input.target.files[0];


        //이미지 보여주는 가공 시작 (base64)
        // const reader = new FileReader();
        // reader.readAsDataURL(inputImage);        
        // new Promise((resolve) => {
        //     reader.onload = () => {
        //         this.setUserImage(reader.result);
        //         resolve();
        //     };
        // });
        //이미지 보여주는 가공 끝 (base64)

        if (fileSize > maxSize) {//파일 사이즈 검사
            this.setGuideImage(this.ErrorGuide_clover_profileImage_size);
        }
        else {
            this.setGuideImage(this.GuideSuccess_profileImage_size);
        }

        if (fileType === 'png') {
            //Buffer 가공 시작
            // const img = new Buffer.from(input.target.value).toString("base64")
            // console.log(img);
            //끝
            //이미지 압축 시작
            // console.log('이미지 압축 시작');
            const option = {
                maxSizeMB: 2.5,
                maxWidthOrHeight: 256,
                useWebWorker: true,
            };
            try {
                const compressedFile = await imageCompression(inputImage, option);// 파일 압축
                const reader = new FileReader();
                reader.readAsDataURL(compressedFile);
                reader.onloadend = () => {
                    const base64data = reader.result;
                    this.setUserImageButtonColor("#4fc3f7");
                    this.setUserImage(base64data);
                    this.setUpDateImage();
                }

            } catch (error) {
                // console.log(error);
                this.setUserImageButtonColor("#ff1744");
            }
            // console.log('이미지 압축 끝');
            //이미지 압축 끝
        }
        else if (fileType === 'jpg' || 'jpeg') {
            //Buffer 가공 시작
            // const img = new Buffer.from(input.target.value).toString("base64")
            // console.log('img===========================================',img);
            //끝
            //이미지 압축 시작
            // console.log('이미지 압축 시작');
            const option = {
                maxSizeMB: 2.5,
                maxWidthOrHeight: 256,
                useWebWorker: true,
            };
            try {
                const compressedFile = await imageCompression(inputImage, option);
                const reader = new FileReader();
                const image = new Image();
                reader.readAsDataURL(compressedFile);
                reader.onloadend = () => {
                    const base64data = reader.result;
                    this.setUserImage(base64data);
                    this.setUpDateImage();
                    this.setUserImageButtonColor("#4fc3f7");
                    image.src = reader.result;
                    image.onload = (result) => {
                        // console.log(result.path[0].width);
                        // console.log(result.path[0].height);
                        const width = result.path[0].width;
                        const height = result.path[0].height;
                        // console.log(result);
                        if (height < width) {
                            this.isBool = true;
                        }
                        else {
                            this.isBool = false;
                        }
                    }
                }
            } catch (error) {
                this.setUserImageButtonColor("#ff1744");
                // console.log('compressedFileError=====================',error);
            }
            // console.log('이미지 압축 끝');
            //이미지 압축 끝
        }
        else {
            return 'fileTypeError'
        }

    };

    setUpDateImage = () => {//유저 프로필 이미지등록
        const member_no = this.loginState.member_no;
        const bool = this.isBool;//이미지 필수 데이터
        const ImageCheck = this.ImageCheckOK;
        const byteArray = this.SignUpImage;
        let strImage = byteArray.replace(/^data:image\/[a-z]+;base64,/, "");
        const ImageData = { 'member_no': parseInt(member_no), 'image': strImage, 'overWidth': bool };
        // console.log(ImageData);

        //이미지 등록
        if (byteArray !== undefined || bool !== undefined) {
            if (ImageCheck === true) {
                const api = '/UploadImage';
                privatePost({ api: api, data: ImageData }, (err, response) => {//이미지 등록 서버전송
                    // console.log(response);
                    if (err) {
                        // console.log(err); 
                    } else {
                        // console.log("setUpDateImage",response?.data);
                        if (response?.data?.result) {
                            this.setImageChange(response?.data?.result?.profile_image);
                            // console.log('UploadImage=================',response?.data?.result);
                        }
                    }
                });
            }
            else {
                // console.log('Imageblank');
            }
        }
        else {
        }//이미지 등록 완료

    }

    setImageChange(image) {
        // console.log(image);
        if (image) {
            this.loginState = new LoginState({ ...this.loginState, profile_image: image });
        } else {
            this.loginState = new LoginState({ ...this.loginState, profile_image: null });
        }
    }


    setUpDateNickname = (value) => {//유저페이지 닉네임등록

        // console.log("setUpDateNickname", value);
        // const member_no = this.loginState.member_no;//닉네임 필수 데이터
        const SignUp_nickname = this.SignUpNickname;
        // const NickNameData = { 'member_no': parseInt(member_no), 'member_nickname': String(SignUp_nickname) };

        //닉네임 등록

        if (SignUp_nickname !== undefined || SignUp_nickname !== null || SignUp_nickname !== "") {
            const api = '/UpdateNickname';
            privatePost({ api: api, data: { 'member_no': parseInt(this.loginState.member_no), 'member_nickname': String(this.SignUpNickname) } }, (err, response) => {//닉네임 등록 서버전송
                // console.log(response);
                if (err) {
                    // console.log(err); 
                    const errorCode = err.errorCode;
                    if (errorCode === 814) {//닉네임 등록 에러처리
                        this.setGuideProfileNicknameColor('#fc0000');
                        this.setGuideProfileNickname(this.ErrorGuide_814);//클로버가 부족합니다
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_814);//클로버가 부족합니다
                        }
                        // return alert('클로버가 부족합니다');
                    }
                    else if (errorCode === 2400) {
                        this.setGuideProfileNicknameColor('#fc0000');
                        this.setGuideProfileNickname(this.ErrorGuide_2400);//클로버 구매를 실패하였습니다
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_2400);//클로버 구매를 실패하였습니다
                        }
                        // return alert('클로버 구매 실패');
                    }
                } else {
                    // console.log(response?.data);
                    if (response?.data?.result) {

                        // console.log('UpdateNickname=================',response?.data?.result);
                        this.setLoginStore(response?.data?.result);


                    }
                }
            });
        }
        else {
            this.setGuideNickNameColor('#fc0000');//Red
        }

        //닉네임 등록 완료


    }

    setGuideProfileNickname(value) {
        this.Guide_clover_profileNickname_count = value;
    }

    setGuideProfileNicknameColor(value) {
        this.GuideProfileNicknameColor = value;
    }

    setUpDateRecommender = (value) => {//유저페이지 추천등록

        // const member_no = this.loginState.member_no;
        const commerce = this.SignUpCommerce;//추천인 필수 데이터
        // const business_code = this.SignUpBusinessCode;

        //추천인 등록
        if (commerce !== undefined || commerce !== null || commerce !== "") {
            const api = '/registRecommender';
            privatePost({ api: api, data: { 'member_no': parseInt(this.loginState.member_no), 'commerce': String(this.SignUpCommerce), 'business_code': String(this.SignUpBusinessCode) } }, (err, response) => {//추천인 등록 서버전송
                // console.log(response);
                if (err) {
                    // console.log(err); 
                    this.setIsRecommenderPage(false);
                    this.setSignUpButton(true);
                    const errorCode = err.errorCode;
                    if (value === "UserprofileRecommender") {
                        if (errorCode === 501) {//추천인 에러 처리
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        }
                        else if (errorCode === 3001) {
                            return alert(this.ErrorGuide_3001);//해당 유저를 찾을수 없습니다
                        }
                        else if (errorCode === 3002) {
                            return alert(this.ErrorGuide_3002);//해당 유저의 추천인 등록 수가 최대치 입니다
                        }
                        else if (errorCode === 3003) {
                            return alert(this.ErrorGuide_3003);//이미추천인을 등록하셨습니다
                        }
                        else if (errorCode === 3004) {
                            return alert(this.ErrorGuide_3004);//자신을 추천인으로 등록 할 수 없습니다
                        }
                        else {
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        }
                    }
                    else {
                        if (errorCode === 501) {//추천인 에러 처리
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        }
                        else if (errorCode === 3001) {
                            return alert(this.ErrorGuide_3001);//해당 유저를 찾을수 없습니다
                        }
                        else if (errorCode === 3002) {
                            return alert(this.ErrorGuide_3002);//해당 유저의 추천인 등록 수가 최대치 입니다
                        }
                        else if (errorCode === 3003) {
                            return alert(this.ErrorGuide_3003);//이미추천인을 등록하셨습니다
                        }
                        else if (errorCode === 3004) {
                            return alert(this.ErrorGuide_3004);//자신을 추천인으로 등록 할 수 없습니다
                        }
                        else {
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        }
                    }
                }
                else {
                    // console.log(response?.data);
                    if (response?.data?.result) {
                        this.setRecommenderData(response?.data?.result);
                        this.setSignUpButton(true);
                        this.rootStore.UserProfileStore.getRecommenderInfo();
                    }
                }
            });
        }
        else {
            // console.log('Recommenderblank');
            this.setGuideRecommenderColor('#fc0000');
        }
        //추천인 등록 완료

    }




    setCheckNickName = (value) => {//닉네임 체크 
        // console.log("start=============", value);

        // const member_no = this.loginState.member_no;
        const member_nickname = this.SignUpNickname;

        const api = '/checkExistNickname';
        if (member_nickname !== "" || member_nickname !== null || member_nickname !== undefined) {//닉네임 빈칸 체크
            privatePost({ api: api, data: { 'member_no': parseInt(this.loginState.member_no), 'member_nickname': String(this.SignUpNickname) } }, (err, response) => {
                if (err) {
                    // console.log(err);
                    this.setSignUpButton(false);
                    const ErrorCode = err.errorCode;
                    if (ErrorCode === 502) {//닉네임 체크 애러처리
                        this.setGuideNickName(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        this.setGuideNickNameColor('#fc0000');//Red   
                        this.setNicknameCheckButtonColor(false);
                        if (value === "UserprofileNickname") {
                            // console.log(value);
                            // return alert("잠시 후 다시 시도해주세요");
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요

                            // this.setGuideProfileNickname("잠시 후 다시 시도해주세요");
                        }

                    }
                    else if (ErrorCode === 810) {
                        this.setGuideNickName(this.ErrorGuide_810);//중복입니다 다시 체크 해주세요
                        this.setGuideNickNameColor('#fc0000');//Red
                        this.setNicknameCheckButtonColor(false);
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_810);//중복입니다 다시 체크 해주세요
                            // this.setGuideProfileNickname("중복입니다 다시 체크 해주세요");
                        }
                    }
                    else if (ErrorCode === 811) {
                        // console.log(ErrorCode);
                        this.setGuideNickName(this.ErrorGuide_811);//빈칸입니다 다시 체크 해주세요
                        this.setGuideNickNameColor('#fc0000');//Red
                        this.setNicknameCheckButtonColor(false);
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_811);//빈칸입니다 다시 체크 해주세요
                            // this.setGuideProfileNickname("빈칸입니다 다시 체크 해주세요");
                        }
                    }
                    else if (ErrorCode === 812) {
                        this.setGuideNickName(this.ErrorGuide_812);//특수문자는 닉네임으로 할 수 없습니다
                        this.setGuideNickNameColor('#fc0000');//Red
                        this.setNicknameCheckButtonColor(false);
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_812);//특수문자는 닉네임으로 할 수 없습니다
                            // this.setGuideProfileNickname("특수문자는 닉네임으로 할 수 없습니다");
                        }
                    }
                    else if (ErrorCode === 813) {
                        this.setGuideNickName(this.ErrorGuide_813);//2글자 이상 20글자 미만으로 해주세요
                        this.setGuideNickNameColor('#fc0000');//Red
                        this.setNicknameCheckButtonColor(false);
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_813);//2글자 이상 20글자 미만으로 해주세요
                            // this.setGuideProfileNickname("2글자 이상 20글자 미만으로 해주세요");
                        }
                    }
                    else if (ErrorCode === 815) {
                        // console.log(err);
                        // const BadWords = err.badwords;
                        // `닉네임에 ${BadWords}은 포함될수 없습니다`
                        this.setGuideNickName(this.ErrorGuide_815);//닉네임에 욕설은 포함될수 없습니다
                        this.setGuideNickNameColor('#fc0000');//Red
                        this.setNicknameCheckButtonColor(false);
                        if (value === "UserprofileNickname") {
                            return alert(this.ErrorGuide_815);//닉네임에 욕설은 포함될수 없습니다
                            // this.setGuideProfileNickname(`닉네임에 ${BadWords}은 포함될수 없습니다`);
                        }
                    }

                } else {
                    // console.log(response?.data.result);
                    // console.log(this.loginState);
                    this.setSignUpButton(true);
                    this.setGuideNickName(this.SuccessGuide_nickName_check);//체크 완료입니다
                    this.setGuideNickNameColor('#0f0ffc');//Blue
                    this.setNicknameCheckButtonColor(true);
                    if (value === "UserprofileNickname") {
                        // console.log(value);
                        // eslint-disable-next-line
                        if (window.confirm(this.GuideCheck_clover_coinStore_message_03) == true) {//닉네임을 등록 하시겠습니까?
                            // console.log("confirmTrue");
                            this.setUpDateNickname("UserprofileNickname");
                        }
                    }
                }
            });
        }
        else {
            // console.log("false");
            this.setGuideNickName(this.ErrorGuide_811);//빈칸입니다 다시 체크 해주세요
            this.setGuideNickNameColor('#fc0000');//Red
            this.setNicknameCheckButtonColor(false);
        }
    }

    setSignUpNickname = (value) => {//닉네임 입력값
        // console.log(value);
        const nickNameValue = value.target.value;
        this.SignUpNickname = nickNameValue;

    };

    setGuideNickName(value) {//닉네임 안내문구
        const length = value.length;
        // console.log(length);
        this.GuideNickName = value;
        this.GuideNickNameLength = length;
    }



    setGuideNickNameColor(color) {//닉네임 안내문구 컬러
        this.GuideNickNameColor = color
        if (color === "#0f0ffc") {
            this.NicknameCheckOK = true;
        }
        else {
            this.NicknameCheckOK = false;
        }
    }

    setNicknameCheckButtonColor(bool) {
        this.NicknameCheckButtonColor = bool;
    }




    setCheckRecommender = (value) => {//추천인 체크 UserprofileRecommender
        // console.log(value);
        // const member_no = this.loginState.member_no;
        const commerce = this.SignUpCommerce;
        // const business_code = this.SignUpBusinessCode;
        if (commerce !== "" || commerce !== null || commerce !== undefined) {//추천인 빈칸 체크
            const api = '/getExistsRecommender';
            privatePost({ api: api, data: { 'member_no': parseInt(this.loginState.member_no), 'commerce': String(this.SignUpCommerce), 'business_code': String(this.SignUpBusinessCode) } }, (err, response) => {//추천인 데이터 서버전송
                // console.log(response);
                if (err) {
                    // console.log(err);
                    this.setRecommenderCheckButtonColor(false);
                    const errorCode = err.errorCode;
                    this.setGuideProfileRecommenderColor('#fc0000');
                    // const errorMessage = err.errorMessage;
                    if (errorCode === 501) {//추천인 에러 처리
                        this.setGuideRecommenderColor('#fc0000');
                        this.setGuideRecommender(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        if (value === "UserprofileRecommender") {
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                            // this.setGuideProfileRecommender('잠시 후 다시 시도해주세요');
                        }
                    }
                    else if (errorCode === 3001) {
                        this.setGuideRecommenderColor('#fc0000');
                        this.setGuideRecommender(this.ErrorGuide_3001);//해당 유저를 찾을수 없습니다
                        if (value === "UserprofileRecommender") {
                            return alert(this.ErrorGuide_3001);//해당 유저를 찾을수 없습니다
                            // this.setGuideProfileRecommender("해당 유저를 찾을수 없습니다");
                        }
                    }
                    else if (errorCode === 3002) {
                        this.setGuideRecommenderColor('#fc0000');
                        this.setGuideRecommender(this.ErrorGuide_3002);//해당 유저의 추천인 등록 수가 최대치 입니다
                        if (value === "UserprofileRecommender") {
                            return alert(this.ErrorGuide_3002);//해당 유저의 추천인 등록 수가 최대치 입니다
                            // this.setGuideProfileRecommender("해당 유저의 추천인 등록 수가 최대치 입니다");
                        }
                    }
                    else if (errorCode === 3003) {
                        this.setGuideRecommenderColor('#fc0000');
                        this.setGuideRecommender(this.ErrorGuide_3003);//이미 추천인을 등록하셨습니다
                        if (value === "UserprofileRecommender") {
                            return alert(this.ErrorGuide_3003);//이미 추천인을 등록하셨습니다
                            // this.setGuideProfileRecommender("이미 추천인을 등록하셨습니다");
                        }
                    }
                    else if (errorCode === 3004) {
                        this.setGuideRecommenderColor('#fc0000');
                        this.setGuideRecommender(this.ErrorGuide_3004);//자신을 추천인으로 등록 할 수 없습니다
                        if (value === "UserprofileRecommender") {
                            return alert(this.ErrorGuide_3004);//자신을 추천인으로 등록 할 수 없습니다
                            // this.setGuideProfileRecommender("자신을 추천인으로 등록 할 수 없습니다");
                        }
                    }
                    else {
                        this.setGuideRecommenderColor('#fc0000');
                        this.setGuideRecommender(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                        if (value === "UserprofileRecommender") {
                            return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                            // this.setGuideProfileRecommender("잠시 후 다시 시도해주세요");
                        }
                    }
                } else {
                    // console.log(response?.data);
                    if (response?.data?.result) {
                        this.setCheckRecommenderData(response?.data?.result);
                        // let RecommenderCheck
                        // console.log('setCheckRecommenderData=================',response?.data?.result);
                        this.setRecommenderCheckButtonColor(true);
                        // confirm("추천인을 등록 하시겠습니까?");
                        if (value === "UserprofileRecommender") {
                            // eslint-disable-next-line
                            if (window.confirm(this.GuideCheck_clover_coinStore_message_04) == true) {//추천인을 등록 하시겠습니까?
                                this.setUpDateRecommender("UserprofileRecommender");
                            }
                            else {
                                return alert(this.Guid_recommender_confirm);//추천인을 확인해주세요
                            }
                        }
                    }
                }
            })
        }
        else {
            this.setGuideRecommender(this.ErrorGuide_811);//빈칸입니다 다시 체크 해주세요
            this.setGuideRecommenderColor('#fc0000');
            if (value === "UserprofileRecommender") {
                this.setGuideProfileRecommenderColor('#fc0000');
                return alert(this.ErrorGuide_811);//빈칸입니다 다시 체크 해주세요
            }

        }
    }

    setSignUpRecommender = (object) => {//추천인 입력값
        // console.log(object.target.value);
        const Recommender = object.target.value;
        const AfterStr = Recommender.split('#');
        // debug("setRecommenderText", AfterStr);
        // debug("setRecommenderText", AfterStr[0]);
        // debug("setRecommenderText", AfterStr[1]);
        this.SignUpCommerce = AfterStr[0];
        if (AfterStr[1] !== undefined) {
            this.SignUpBusinessCode = AfterStr[1];
        }
        else {
            this.SignUpBusinessCode = null;
        }
    };

    setGuideRecommender(value) {//추천인 안내문구
        this.GuideRecommender = value
    }

    setGuideRecommenderColor(color) {//추천인 안내문구 컬러
        this.GuideRecommenderColor = color
        if (color === '#31ea4e' || color === '#0f0ffc') {
            this.RecommenderCheckOK = true;
        }
        else {
            this.RecommenderCheckOK = false;
        }

    }


    setGuideProfileRecommenderColor(vlaue) {
        this.GuideProfileRecommenderColor = vlaue;
    }

    setCheckRecommenderData(data) {//추천인 체크 후 받아온 데이터
        this.CheckRecommenderData = data;
        const Recommender = data.can_upgrade;
        // console.log('setCheckRecommenderData',data);
        if (Recommender === true) {
            this.setGuideRecommenderColor('#31ea4e');//Green
            this.setGuideRecommender(this.SuccessGuide_message);//완료되셨습니다
        }
        else {
            this.setGuideRecommenderColor('#0f0ffc');//Blue
            this.setGuideRecommender(this.SuccessGuide_message);//완료되셨습니다
        }
    }
    setRecommenderCheckButtonColor(bool) {
        this.RecommenderCheckButtonColor = bool;
    }

    setSignUp = () => {//회원가입 버튼
        const member_no = this.loginState.member_no;//닉네임 필수 데이터
        const SignUp_nickname = this.SignUpNickname;
        const NicknameCheck = this.NicknameCheckOK;
        const NickNameData = { 'member_no': parseInt(member_no), 'member_nickname': String(SignUp_nickname) };

        const bool = this.isBool;//이미지 필수 데이터
        const ImageCheck = this.ImageCheckOK;
        const byteArray = this.SignUpImage;
        let strImage = byteArray.replace(/^data:image\/[a-z]+;base64,/, "");
        const ImageData = { 'member_no': parseInt(member_no), 'image': strImage, 'overWidth': bool };

        const commerce = this.SignUpCommerce;//추천인 필수 데이터
        const business_code = this.SignUpBusinessCode;
        const RecommenderCheck = this.RecommenderCheckOK;
        const Recommender = { 'member_no': parseInt(member_no), 'commerce': String(commerce), 'business_code': business_code };


        //닉네임 등록

        if (SignUp_nickname !== undefined || SignUp_nickname !== null || SignUp_nickname !== "") {
            if (NicknameCheck === true) {
                // eslint-disable-next-line
                if (window.confirm("닉네임을 등록하시겠습니까?") == true) {
                    const api = '/UpdateNickname';
                    privatePost({ api: api, data: NickNameData }, (err, response) => {//닉네임 등록 서버전송
                        // console.log(response);
                        if (err) {
                            // console.log(err); 
                            const errorCode = err.errorCode;
                            if (errorCode === 814) {//닉네임 등록 에러처리
                                this.setGuideRecommenderColor('#fc0000');
                                return alert(this.ErrorGuide_814);//클로버가 부족합니다
                            }
                            else if (errorCode === 2400) {
                                this.setGuideRecommenderColor('#fc0000');
                                return alert(this.ErrorGuide_2400);//클로버 구매를 실패하였습니다
                            }
                        } else {
                            // console.log(response?.data);
                            if (response?.data?.result) {
                                this.setLoginStore(response?.data?.result);
                                // console.log('UpdateNickname=================',response?.data?.result);
                            }
                        }
                    });
                }
            }
            else {
                this.setGuideNickNameColor('#fc0000');//Red
            }

        }
        else {
            this.setSignUpButton(false);
        }//닉네임 등록 완료

        //이미지 등록
        if (byteArray !== undefined || bool !== undefined) {
            if (ImageCheck === true) {
                const api = '/UploadImage';
                privatePost({ api: api, data: ImageData }, (err, response) => {//이미지 등록 서버전송
                    // console.log(response);
                    if (err) {
                        // console.log(err); 
                        this.setSignUpButton(true);
                    } else {
                        // console.log(response?.data);
                        if (response?.data?.result) {
                            // this.setLoginStore(response?.data?.result);
                            this.setImageChange(response?.data?.result?.profile_image);
                            this.setSignUpButton(true);
                            // console.log('UploadImage=================',response?.data?.result);
                        }
                    }
                });
            }
            else {
                // console.log('Imageblank');
            }
        }
        else {
            this.setSignUpButton(true);
        }//이미지 등록 완료

        //추천인 등록
        if (commerce !== "" || commerce !== null || commerce !== undefined) {
            if (RecommenderCheck === true) {
                // eslint-disable-next-line
                if (window.confirm("추천인을 등록하시겠습니까?") == true) {
                    const api = '/registRecommender';
                    privatePost({ api: api, data: Recommender }, (err, response) => {//추천인 등록 서버전송
                        // console.log(response);
                        if (err) {
                            // console.log(err); 
                            this.setIsRecommenderPage(false);
                            this.setSignUpButton(true);
                            const errorCode = err.errorCode;
                            if (errorCode === 501) {//추천인 에러 처리
                                return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                            }
                            else if (errorCode === 3001) {
                                return alert(this.ErrorGuide_3001);//해당 유저를 찾을수 없습니다
                                // return alert("해당 유저를 찾을수 없습니다");
                            }
                            else if (errorCode === 3002) {
                                return alert(this.ErrorGuide_3002);//해당 유저의 추천인 등록 수가 최대치 입니다
                                // return alert("해당 유저의 추천인 등록 수가 최대치 입니다");
                            }
                            else if (errorCode === 3003) {
                                return alert(this.ErrorGuide_3003);//이미추천인을 등록하셨습니다
                                // return alert("이미추천인을 등록하셨습니다");
                            }
                            else if (errorCode === 3004) {
                                return alert(this.ErrorGuide_3004);//자신을 추천인으로 등록 할 수 없습니다
                                // return alert("자신을 추천인으로 등록 할 수 없습니다");
                            }
                            else {
                                return alert(this.ErrorGuide_501);//잠시 후 다시 시도해주세요
                                // return alert('잠시 후 다시 시도해주세요');
                            }
                        } else {
                            // console.log(response?.data);
                            if (response?.data?.result) {
                                this.setRecommenderData(response?.data?.result);
                                this.setSignUpButton(true);
                                // if (response?.data?.result.business_code !== undefined || response?.data?.result.business_code !== null || response?.data?.result.business_code !== "") {
                                //     this.setIsRecommenderPage(true);
                                // }
                                // else {
                                //     this.setIsRecommenderPage(false);
                                // }
                            }
                        }
                    });
                }
                else {
                    // console.log('Recommenderblank');
                    this.setGuideRecommenderColor('#fc0000');
                }
            }
        }
        else {
            this.setSignUpButton(true);
        }//추천인 등록 완료

        this.setDialogClose("SignupFalse")

    };

    setUserImageButtonColor(value) {
        this.UserFrofileImageButtonColor = value;
    }

    setRecommenderData(RecommenderData) {
        this.RecommenderData = RecommenderData;
        // if(businessGrade === 1) {
        // // this.setIsRecommenderPage(true);//MiningBar 보기
        // }else {
        //     this.setIsRecommenderPage(false);//MiningBar 보기
        // }
    }

    setSignUpButton(bool) {//회원가입 버튼 활성화
        this.isSignUpButtonAction = bool;
    }


    setIsMainPage(bool) {//(UserBar)보이기 여부
        // console.log(bool);
        this.isMainPage = bool;
    }

    setIsRecommenderPage(bool) {//(MiningBar)보이기 여부
        // console.log('set ',bool);
        this.isRecommenderPage = bool;
    }

    SignUpRefresh = () => {// 회원가입 새로고침
        this.SignUpImage = '';
        this.SignUpNickname = '';
        this.SignUpCommerce = '';
        this.GuideNickName = '중복 체크 해주세요';
        this.GuideNickNameLength = '';
        this.GuideNickNameColor = 'red';
        this.GuideImage = '프로필 사진을 등록 해주세요';
        this.GuideRecommenderColor = 'blue';
        this.GuideRecommender = '검색해주세요';
        this.NicknameCheckButtonColor = false;
        this.RecommenderCheckButtonColor = false;
        // this.setIsLogin(false);
        this.getipChack();
    }

    async getCloverCount(value) {//Clover 받아오기
        // console.log(value);
        const api = '/getCloverCount';
        const member_no = this.loginState.member_no;
        // console.log("getCloverCountStart",api);
        await privatePost({ api: api, data: { 'member_no': parseInt(member_no) }, }, (err, response) => {
            // console.log("getCloverCountStart1",api);
            if (err) {
                // console.log(err);
            }
            else {
                if (response?.data?.result) {
                    // console.log("2",response);
                    // console.log("2",response?.data);
                    // console.log("2",response?.data?.result);
                    const Count = response?.data?.result?.clover_count;
                    this.setCloverCount(Count);
                    // console.log("getCloverCountEnd");
                }
            }
        }, "getcloverCount")

    }

    setCloverCount(value) {//Clover 저장
        // console.log("setCloverCount",value);
        this.CloverCount = value;
    }



    setIsLogin(isLogin) {
        this.isLogin = isLogin;
        setSession("isLogin", isLogin);
    }
    setLoginFail(loginFail) {
        this.loginFail = loginFail;
    }
    setLoginStore(memberData) {
        this.loginState = new LoginState(memberData);
        if (memberData)
            setSessionJson('userInfo', memberData);
        // window.location.reload();//(UserBar)보이기 여부(MiningBar)보이기 여부 

    }

    logOut() {
        // console.log("LogOut");
        const member_no = this.loginState.member_no;
        const api = '/auth/logout';
        privatePost({ api: api, data: { 'member_no': parseInt(member_no) } }, (err, response) => {
            // console.log(response);
            if (err) {
            } else {
                clearAll();
                window.location.href = 'https://www.earn-clover.com/';
            }
        });
    }

}